/**
 * Common Style
 */

import { theme } from './theme';
import { StyleSheet, Dimensions, StatusBar, Platform } from 'react-native';
import {
  getDeviceHeight,
  getDeviceWidth,
  isAndroid,
  isIOS,
  isWeb,
} from './utils/Helper';
import { LANDSCAPE_ENABLED } from './config/Constant';
const { width, height } = Dimensions.get('window');



export const PRIMARY_FONT = theme?.PRIMARY_FONT || {
  fontFamily: 'AlegreSans-Regular',
  fontWeight: 400,
}

export const SECONDARY_FONT = theme?.SECONDARY_FONT || {
  fontFamily: 'Plain-Regular',
  fontWeight: 400,
}

export const FONT_XSMALL = theme?.FONT_XSMALL || {
  fontSize: 10,
  lineHeight: 16,
  letterSpacing: -0.2,
  fontWeight: 500
}

export const FONT_SMALL = theme?.FONT_SMALL || {
  fontSize: 14,
  lineHeight: 21,
}

export const FONT_MEDIUM = theme?.FONT_MEDIUM || {
  fontSize: 16,
  lineHeight: 24,
}

export const FONT_LARGE = theme?.FONT_LARGE || {
  fontSize: 24,
  lineHeight: 30,
}

export const FONT_XLARGE = theme?.FONT_XLARGE || {
  fontSize: 40,
  lineHeight: 44,
}

export const FONT_XXLARGE = theme?.FONT_XXLARGE || {
  fontSize: 48,
  lineHeight: 52,
}


export const COLORS = {
  WHITE: "#ffffff",
  BLACK: "#000000",
  LIGHT_GREY: "#F5F5F5",
  DARK_GREY: "#999999",

  SUCCESS: "rgba(93, 118, 77, 1)",
  SUCCESS_CONTRAST: "#FFFFFF",
  ERROR: "rgba(196, 106, 104, 1)",
  ERROR_CONTRAST: "#000000",

  BACKGROUND_COLOR: '#F1F0E4', // background color for main containers
  BACKGROUND_COLOR_CONTRAST: '#1D1D1D',

  BACKGROUND_COLOR_SECONDARY: "#1D1D1D", // secondary background color (eg: footer)
  BACKGROUND_COLOR_SECONDARY_CONTRAST: "#FFFFFF",

  PRIMARY_COLOR: "#FFFFFF", // primary color
  PRIMARY_TEXT_COLOR: "#1D1D1D", // primary text color

  SECONDARY_COLOR: "#1D1D1D", // secondary color
  SECONDARY_TEXT_COLOR: "#ffffff", // secondary text color

  ACCENT_COLOR: "#BD2611",
  ACCENT_Text_COLOR: "#FFFFFF",


  ...theme?.COLORS,
}

export const GENERAL_MAX_WIDTH = theme?.GENERAL_MAX_WIDTH || 450



export default StyleSheet.create({

  rootContainer: {
    flex: 1,
    margin: "auto",
    width: "100%",
    maxWidth: !LANDSCAPE_ENABLED ? GENERAL_MAX_WIDTH : undefined
  },


  /**
 * 
 * MAIN LAYOUT
 * 
 */
  tabBarStyle: {
    position: "absolute",
    bottom: 0,
    height: 84,
    width: "100%",
    backgroundColor: COLORS.BACKGROUND_COLOR_SECONDARY,
    paddingLeft: 0,
    paddingRight: 0,
  },
  tabContainerTopBorder_container: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  },
  tabContainerTopBorder: {
    borderTopWidth: 3,
    borderTopColor: COLORS.ACCENT_COLOR,
  },
  tabContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign : "center",
    paddingTop: 6,
    gap: 8,
    flex: 1,
  },
  tabParentContainer:{

  },
  tabFocusedContainer: {

  },
  tabLabel: {
    ...SECONDARY_FONT,
    ...FONT_XSMALL,
    textTransform: 'uppercase',
    textAlign : 'center',
    color: COLORS.BACKGROUND_COLOR_SECONDARY_CONTRAST,
  },
  tabLabelFocused: {
    color: COLORS.BACKGROUND_COLOR_SECONDARY_CONTRAST,
  },
  tabIcon: {
    width: 24,
    height: 24,
  },
  tabIconFocused: {

  },


  tabBarStyle_landscape: {
    backgroundColor: COLORS.BACKGROUND_COLOR_SECONDARY,
    paddingTop: 56,
    paddingBottom: 56
  },
  tabParentContainer_landscape: { 
    flex: 1,
    flexDirection: 'column', 
    alignItems: 'center' 
  },
  tabContainerTopBorder_container_landscape: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    height: 80,
  },
  tabContainerTopBorder_landscape: {
    width: 80,
    height: 80,
    backgroundColor: COLORS.ACCENT_COLOR,
  },
  tabContainer_landscape: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 2,
    padding: 6,
    width: 80,
    height: 80
  },
  tabFocusedContainer_landscape: {
    
  },
  tabIcon_landscape: {
    width: 24,
    height: 24,
    objectFit: 'contain',
    resizeMode: 'contain',
  },
  tabIconFocused_landscape: {
    // filter: 'invert(1)',
    // tintColor: COLORS.ACCENT_Text_COLOR,
  },
  tabLabel_landscape: {
    ...SECONDARY_FONT,
    ...FONT_XSMALL,
    textTransform: 'uppercase',
    color: COLORS.BACKGROUND_COLOR_SECONDARY_CONTRAST,
  },
  tabLabelFocused_landscape: {
    color: COLORS.ACCENT_Text_COLOR,
  },


  errorContainer: {
    flex: 1,
    width: "100%",
    margin: "auto",
    justifyContent: "center",
    alignItems: 'center',
    padding: 16,
    gap: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR,
    maxWidth: GENERAL_MAX_WIDTH
  },
  errorTitle: {
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  errorImage: {
    height: "40%",
    resizeMode: 'contain',
  },
  errorMessage: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  errorRetryButton: {

  },
  errorRetryText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: 'center',
    color: '#007BFF',
  },
  errorHereText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    fontWeight: 'bold',
  },
  errorDetails: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textAlign: "center",
    color: 'red',
  },


  /* Main HomePage Container */
  mainRootContainer: {
    flex: 1,
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  mainContainer: {
    flex: 1,
    // marginTop: 393,
    // backgroundColor: COLORS.BACKGROUND_COLOR,
    // height: 393
  },
  mainContainerParallaxContainer: {
    marginTop: 246,
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  mainContainerHeaderContainer: {
    display: "flex",
    justifyContent: 'center',
    width: "100%"
  },
  mainContainerHeaderImg: {
    width: "100%",
    height: 393,
    maxWidth: 1000,
    margin: "auto",
    objectFit: "cover"
  },
  mainContainerHeaderTitleContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: 'center',
    gap: 16,
    paddingVertical: 32,
    paddingHorizontal: 16
  },
  mainContainerHeaderTitle: {
    ...PRIMARY_FONT,
    ...FONT_XXLARGE,
    textTransform: "uppercase",
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  mainContainerWidgetsContainer: {
    paddingBottom: 148
  },
  mainContainer_logout_button: {
    paddingTop: 24,
    paddingHorizontal: 16, 
    paddingBottom: 40
  },

  /** Bookmark popup */
  bookmarkRootContainer: {
    position: "absolute", 
    bottom: 60, 
    maxWidth: 300, 
    paddingHorizontal: 8, 
    alignItem: "center", 
    zIndex: 1000, 
    backgroundColor: COLORS.BACKGROUND_COLOR, 
    justifySelf: "center", 
    alignSelf: "center", 
    margin: "auto", 
    borderRadius: 10,

    borderWidth: 0.5,
    borderColor: "rgba(0, 0, 0, 0.1)",

    elevation: 2,
    // iOS shadow styles
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  }, 
  bookmarkTextContainer: {
    padding: 16
  },
  bookmarkTextCloseContainer: {
    position: "absolute",
    right: 12
  },
  bookmarkTextCloseText: {
    ...FONT_SMALL,
    ...PRIMARY_FONT,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  bookmarkPopupText: {
    ...FONT_XSMALL,
    ...PRIMARY_FONT,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    paddingRight: 12,
    paddingTop: 12,
  },

   /**
 *
 * INFO MULTIPLE WIDGET STYLE
 *
  ₹ */
  infoMultipleWidgetContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 16,
    padding: 16,
    backgroundColor: COLORS.PRIMARY_COLOR,
  },
  infoMultipleHeaderTitle: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: 'center'
  },
  infoMultipleHeaderSubtitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingHorizontal: 24,
    textAlign: "center"
  },
  infoMultipleImageStyle: {
    width: '100%',
    height: 230,
    objectFit: "cover"
  },
  infoMultipleButtonContainer: {
    display: "flex",
    justifyContent: 'center',
    alignItems: 'center',
    width: "100%",
    height: 48,
    paddingHorizontal: 24,
    paddingVertical: 8,
    borderWidth: 1,
  },
  infoMultipleButtonContainerText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  /**
 *
 * INFO WIDGET STYLE
 *
  ₹ */
  infoWidgetsWidgetContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 16,
    padding: 16,
    backgroundColor: COLORS.PRIMARY_COLOR,
  },
  infoWidgetHeaderTitle: {
    ...PRIMARY_FONT,
    ...FONT_XXLARGE,
    textTransform: "uppercase",
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: 'center'
  },
  infoWidgetHeaderSubtitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingHorizontal: 24,
    textAlign: "center"
  },
  infoWidgetImageStyle: {
    width: '100%',
    height: 230,
    objectFit: "cover"
  },
  infoWidgetButtonContainer: {
    display: "flex",
    justifyContent: 'center',
    alignItems: 'center',
    width: "100%",
    height: 48,
    paddingHorizontal: 24,
    paddingVertical: 8,
    borderWidth: 1,
  },
  infoWidgetButtonContainerText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },

    /**
 *
 * INFO WIDGET STYLE LANDSCAPE
 *
  ₹ */
  infoWidgetsWidgetContainer_landscape: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 16,
    padding: 16,
    backgroundColor: COLORS.PRIMARY_COLOR,
  },
  infoWidgetHeaderTitle_landscape: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: 'center'
  },
  infoWidgetHeaderSubtitle_landscape: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingHorizontal: 24,
    textAlign: "center"
  },
  infoWidgetImageStyle_landscape: {
    width: '100%',
    height: 230,
    objectFit: "cover"
  },
  infoWidgetButtonContainer_landscape: {
    display: "flex",
    justifyContent: 'center',
    alignItems: 'center',
    width: "100%",
    height: 48,
    paddingHorizontal: 24,
    paddingVertical: 8,
    borderWidth: 1,
  },
  infoWidgetButtonContainerText_landscape: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },

  /**
   * Way Activities
   */

  wayBookingsLoader: {
    tintColor: COLORS.BLACK,
  },

  activitiesBookingMainContainerChildContainer: {
    marginBottom: 90
  },
  activitiesCreateBookingTimeSlots: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    marginTop: 12
  },
  activitiesCreateBookingNoSessions: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "none"
  },

  activitiesBookingCheckedBox: {
    display: "flex",
    width: 20,
    height: 20,
    // borderWidth: 1,
    // borderColor: 'grey',
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.ACCENT_COLOR,
  },

  activitiesEventListHeaderContainer: {
    gap: 8,
    marginBottom: 8,
    paddingHorizontal: 16,

    display: "flex",
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
  },
  activitiesEventListFilterMainContainer: {
    paddingHorizontal: 30,
    gap: 8,
  },
  activitiesBookingMainContainerHeader: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginVertical: 8
  },
  activitiesBookingMainPageHeaderTitleContainer: {
    justifyContent: "center",
    alignItems: "center",
  },
  activitiesBookingHeaderTitleContainer: {
    justifyContent: "center",
    alignItems: "center",
  },
  activitiesBookingHeaderTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "none",
    textAlign: "left",
    width: "100%"
  },
  activitiesBookingEventListHeaderTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "none",
    textAlign: "center",
    width: "100%"
  },
  activitiesBookingHeaderSubTitle: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingHorizontal: null,
    textAlign: "left",
    width: "100%"
  },
  activitiesBookingHeaderSubTitle2: {
    paddingHorizontal: null,
    textAlign: "left",
    width: "100%"
  },
  activitiesBookingSubItemContainer: {
    display: "flex",
    // justifyContent: "space-between",
    flexDirection: "row",
  },
  activitiesBookingItemDay: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginTop: 16,
  },
  activitiesBookingDateContainer: {
    gap: 4,
    flex: 1
  },
  activitiesBookingBookingExperienceText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  activitiesBookingBookingExperienceDate: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  activitiesBookingEditButtonContainer: {
    // height: 20,
    // width: 20
  },
  activitiesBookingEditButton: {
    height: 20,
    width: 20,
    objectFit: "cover"
  },
  activitiesBookingOverviewHeadingText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginBottom: 8
  },
  activitiesBookingOverviewHeadingPriceTierText: {
    marginBottom: null
  },
  activitiesBookingOverviewTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginBottom: 16
  },
  activitiesBookingOverviewParticipantsContainer: {
    minHeight: 60
  },
  activitiesBookingOverviewParticipantsItemContainer: {
    marginVertical: 8
  },
  activitiesBookingOverviewParticipantsItemText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  activitiesBookingNoReservationFoundContainer: {
    flexDirection: "row"
  },
  activitiesBookingNoReservationTxt: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  activitiesBookingNoReservationRetry: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    fontWeight: "black"
  },

  activitiesEventListFilterContainer: {
    borderRadius: 16,
    borderWidth: 1,
    backgroundColor: COLORS.PRIMARY_COLOR,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderColor: "rgba(0, 0, 0, 0.10)"
  },
  activitiesEventListTextContainer: {
    paddingHorizontal: 16,
  },
  activitiesBookingOverviewTextContainer: {
    marginBottom: 8,
    marginTop: 16,
  },
  activitiesEventListItemImage: {
    objectFit: "cover",
    height: 165,
    borderRadius: 8,
  },
  activitiesEventListItemContent: {
    // height: 135,
    flex: 1,
    justifyContent: "center",
    marginBottom: 24,
    gap: 4
  },
  activitiesEventListItemSubContent: {
    height: 140,
  },
  activitiesSubEventListItemContainer: {
    paddingHorizontal: 16,
    flexDirection: "row",
    alignItems: "flex-start",
  },
  activitiesEventList_itemContainer_arrow: {
    justifySelf: "center",
    alignSelf: 'center'
  },
  activitiesEventList_itemContainer_selected: {
    backgroundColor: COLORS.ACCENT_COLOR
  },
  activitiesEventList_itemContainer_image_selected: {

  },
  activitiesSubEvent_itemContainer_textContainer_selected: {

  },
  activitiesSubEventListItemImageContainer: {
    height: 145,
    width: 145,
  },
  activitiesSubEventListItemImage: {
    objectFit: "cover",
    height: 145,
    width: 145,
    borderRadius: 8,
  },
  emptyStateText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  activitiesEventListContainer: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingVertical: 16
  },
  activitiesEventListItemTitleContainer: {
    marginTop: 14,
  },
  activitiesEventListItemTitle: {
    color: COLORS.PRIMARY_TEXT_COLOR,
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    marginTop: 8
  },
  activitiesEventListItemSubtitle: {
    color: COLORS.PRIMARY_TEXT_COLOR,
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
  },
  activitiesCreateBookingItemContainer: {
    paddingVertical: null,
  },
  
  activitiesEventListFilterContainerActive: {
    backgroundColor: COLORS.SECONDARY_COLOR,
    borderColor: COLORS.SECONDARY_COLOR,
  },
  activitiesEventListFilterName: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  activitiesEventListFilterNameActive: {
    color: COLORS.SECONDARY_TEXT_COLOR
  },

  activitiesEventListMainContainerChildContainer: {
    paddingHorizontal: 16,
    marginBottom: 88
  },
  activitiesSubEventListMainContainerChildContainer: {
    paddingHorizontal: 0,
    marginBottom: 88
  },

  activitiesCreateBookingMainContainerChildContainer: {
    marginBottom: 88
  },
  
  activitiesCreateBookingTimeSlotsContainer: {
    flexDirection: "row",
    gap: 8,
    marginVertical: 12
  },
  activitiesEventTitleText: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center",
    paddingVertical: 32
  },
  activitiesFirstAvailableDateText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingTop: 4
  },
  activitiesFirstAvailableDateLabel: {
    marginBottom: 12
  },
  spaBookingRetryButtonContainer: {
    color: COLORS.SECONDARY_COLOR
  },

  activitiesCreateBookingAddonHeading: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  activitiesCreateBookingButtonContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: 'center',
    gap: 16,
  },
  activitiesCreateBookingButtonMinusContainer: {

  },
  activitiesCreateBookingButtonAddMinus: {
    width: 24,
    height: 24,
  },
  
  activitiesCreateBookingButtonQuantityText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  activitiesCreateBookingTimeSlotsItemContainer: {
    padding: 8,
    borderWidth: 1,
    borderColor: COLORS.BLACK,
    borderRadius: 5
  },

  activitiesCreateBookingTimeSlotsItemSelectedContainer: {
    backgroundColor: COLORS.SECONDARY_COLOR,
  },
  activitiesCreateBookingTimeSlotsItemSelectedText: {
    color: COLORS.SECONDARY_TEXT_COLOR,
  },

  activitiesBookingNextButtonContainer: {
    bottom: 0,
    width: '100%',
    position: 'absolute',
    padding: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR,
    gap: 10,
  },
  
  activitiesCreateBookingSelectedEventContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 16,
  },
  activitiesCreateBookingSelectedEventTextContainer: {
    maxWidth: 262,
    gap: 4
  },
  activitiesCreateBookingSelectedEventTextName: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  activitiesCreateBookingSelectedEventTextPrice: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  activitiesCreateBookingHeaderTitleContainer: {
    gap: null,
    alignItems: "flex-start"
  },

  activitiesAdditionlaDetailsHeaderTitleContainer: {
    // justifyContent: "flex-start",
    // alignItems: "flex-start",
    // paddingBottom: 8,
  },
  activitiesAdditionlaDetailsHeaderTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center"
  },
  activitiesAdditionlaDetailsHeaderSubTitle: {

  },
  
  activitiesCreateBookingSelectedEventButtonContainer: {
    flexDirection: "row",
    gap: 8,
    justifyContent: "center",
    alignItems: "center"
  },

  activitiesCreateBookingSelectedEventMinusButtonContainer: {
    height: 23,
    width: 23
  },
  activitiesCreateBookingSelectedEventMinusButton: {
    objectFit: "cover",
    height: 23,
    width: 23
  },
  activitiesCreateBookingSelectedEventAddButtonContainer: {
    height: 23,
    width: 23
  },
  activitiesCreateBookingSelectedEventAddButton: {
    objectFit: "cover",
    height: 23,
    width: 23
  },

  activitiesCreateBookingCancellationPolicyContainer: {
    marginVertical: 12
  },
  activitiesCreateBookingCancellationPolicyTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "none"
  },
  activitiesCreateBookingCancellationPolicySubDescription: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "none"

  },
  activitiesCreateBookingSelectHeading: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginTop: 8
  },
  activitiesCreateBookingSelectSubHeading: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  activitiesDynamicFormContainer: {
    gap: 8,
    marginVertical: 8
  },
  activitiesDynamicFormContainerText: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginTop: 8,
  },
  activitiesDynamicFormItemContainer: {
    gap: 8,
    marginTop: 8
  },
  activitiesDynamicFormItemContainerHeading: {
    marginVertical: 8,
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR
  },

  activitiesAdditionlaDetailsTextCotainer: {
    // flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: 8,

  },
  activitiesAdditionlaDetailsTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "none"
  },
  activitiesAdditionlaDetailsTitleText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "none",
    // textAlign: "right"
  },
  activitiesBookingUpdateHeaderTitleContainer: {
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: 0,
  },
  termnsAndConditionContainer: {
    flexDirection: "row",
  },
  checkboxContainerText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  termsAndConditionCheckboxText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingLeft: 8,
  },
  termsAndConditionText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: "#0000EE"
  },

  activitiesCreateBookingHeaderContainer: {
    justifyContent: "center",
    alignItems: "center",

  },
  activitiesCreateBookingHeaderTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginBottom: 12,
    textTransform: "none"
  },

  activitiesCreateBookingHeaderDescription: {
    ...FONT_MEDIUM,
    ...SECONDARY_FONT,
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingHorizontal: 0,
    textAlign: "center"
  },
  activitiesConfirmationBookingHeaderDescription: {
    ...FONT_MEDIUM,
    ...SECONDARY_FONT,
    color: COLORS.PRIMARY_TEXT_COLOR,
    // marginBottom: 18,
    textAlign: "center"
  },
  activitiesBookingCancelButtonContainer: {
  },
  activitiesBookingCancelledButton: {
    tintColor: COLORS.PRIMARY_TEXT_COLOR,
    filter: "invert(1)"
  },
  



  /**
 *
 * GUEST DETAILS WIDGET STYLE
 *
 */

  guestDetailsWidgetContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 8,
    padding: 16,
    backgroundColor: COLORS.PRIMARY_COLOR,
    // marginTop: 24
  },
  guestDetailsHeaderTitle: {
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    textTransform: "uppercase",
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: 'center'
  },
  guestDetailsHeaderSubtitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center"
  },
  guestDetailsImageStyle: {
    width: '100%',
    height: 230,
    margin: "auto",
    objectFit: 'contain',
    resizeMode: 'contain'
  },
  guestDetailsButtonContainer: {
    display: "flex",
    justifyContent: 'center',
    alignItems: 'center',
    width: "100%",
    paddingVertical: 8,
    gap: 12
  },
  guestDetailsButtonContainerText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  guestDetailsDateContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: 'space-between',
    marginVertical: 24,
    gap: 8,
  },
  guestDetailsDateItemContainer: {
    borderWidth: 0.5,
    borderColor: COLORS.ACCENT_COLOR,
    width: 100,
    paddingVertical: 16,
    paddingHorizontal: 10
  },
  guestDetailsDateItemDurationContainer: {
    flex: 1,
    width: "auto",
  },
  guestDetailsDateItemTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    fontWeight: '400',
    textAlign: 'center',
    alignSelf: 'center',
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  guestDetailsDateItemSubTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    fontWeight: '400',
    textAlign: 'center',
    alignSelf: 'center',
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  /**
   * Info Page Scroll Update
   */
  infoPageScrollWidgetsWidgetContainer:{
    paddingHorizontal: 0,
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: 0,
    paddingVertical: 40,
    alignItems: "center",
  },
  infoPageScrollWidgetHeaderTitle:{

  },
  infoPageScrollWidgetHeaderSubtitle: {
    color: COLORS.SECONDARY_TEXT_COLOR,
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    position: 'absolute',
    bottom: 75,
    textAlign: "center",
    paddingHorizontal: 20,
    lineHeight: 24
  },
  infoPageScrollWidgetImageStyle:{
    height: 320,
    objectFit: 'cover',
    width: '100%',
  },
  infoPageScrollWidgetButtonContainer:{
    backgroundColor: "transparent",
    position: 'absolute',
    bottom: 85,
    borderBottomWidth: 2,
    borderColor: COLORS.WHITE,
  },
  infoPageScrollWidgetButtonContainerText:{
    color: COLORS.SECONDARY_TEXT_COLOR,
    ...SECONDARY_FONT,
    ...FONT_LARGE,
    // textDecorationLine: 'underline',
  },
  infoPageScrollMainContainerChildContainer:{
    top: -80,
    marginBottom: -50
  },
  infoPageScrollPaginationDot:{
    borderColor: COLORS.WHITE,
    height: 8,
    width: 8
  },
  infoPageScrollActivePaginationDot:{
    backgroundColor: COLORS.WHITE
  },

  /**
   * Guest Itinerary Style
   * 
   */
  guestitinerary_RootContainer: {
    flex: 1,
  },
  guestitinerary_MainContainerChildContainer: {
    flex: 1,
    flexDirection: "column",
    // padding: 16,
    gap: 10,
    width: "100%",
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.10)"
  },
  guestitinerary_MainContainerChildItem: {
    display: 'flex',
    flexDirection: "column",
    // paddingVertical: 16,
    // gap: 10,
    width: "100%",
    backgroundColor: COLORS.PRIMARY_COLOR,
  },
  guestitinerary_MainContainerChildItemHeaderTitle: {
    marginTop: 20,
    marginBottom: 12,
  },
  guestitinerary_MainContainerChildItemContainer: {
    borderLeftWidth: 5,
    borderLeftColor: COLORS.ACCENT_COLOR,
    paddingLeft: 12,
    justifyContent: 'center',
    height: 56
  },
  guestitinerary_MainContainerChildItemTitle:{
    paddingBottom: 10
  },

  guestItineraryMainContainerChildContainer: {
    backgroundColor: COLORS.WHITE,
    paddingHorizontal: 0,
    minHeight: 175,
    borderRadius: 10,
  },

  guestitinerary_HeaderTitleContainer: {
    paddingBottom: 8,
  },

  guestItineraryWidgetBookmarkIcon: {
    width: 24,
    height: 24
  },
  
  guestItineraryWidgetHeaderContainer: {
    marginTop: 0,
    alignItems: "center"
  },

  guestitinerary_HeaderTitle: {
    ...FONT_LARGE,
    ...PRIMARY_FONT,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },


  /** 
   * On Demand Widget
  */
  onDemandmainContainer: {
    paddingHorizontal: 0
  },
  onDemandHeaderContainer: {
    display: "none"
  },
  onDemandRootContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
    overflow: 'hidden',
  },
  onDemandMainContainer: {
    flex: 1,
    overflow: "hidden",
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  
  onDemand: {
    width: '100%',
    height: '100%',
    border: 'none',
    overflow: "hidden",
    backgroundColor: COLORS.BACKGROUND_COLOR,
    flex: 1,
    paddingHorizontal: 16
  },
  onDemandMainContainerChildContainer: {
    height: "100%",
    paddingHorizontal: 0,
  },


  /**
   * TV Remote Landscape
   */
  tvRemoteMainContainer_landscape: {

  },

  tvRemoteFilterContainer: {
    display: "flex",
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    marginBottom: 0
  },
  tvRemoteFooterButtonItemContainer_landscape: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderColor: "rgba(0, 0, 0, 0.10)"
  },
  tvRemoteFooterButton_landscape: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  tvRemoteFooterActiveContainer_landscape: {
    borderColor: COLORS.ACCENT_COLOR,
    backgroundColor: COLORS.SECONDARY_COLOR,
    borderRadius: 5,
    padding: 10
  },
  tvSelectItemListContainer_landscape: {
    gap: 16,
    flexDirection: "row",
    flexWrap: "wrap"
  },
  tvSelectListItemContainer: {
    flex: 1, 
    paddingVertical: 0, 
    maxWidth: 300
  },
  tvRemoteFooterActiveButton_landscape: {
    color: COLORS.ACCENT_Text_COLOR
  },
  tvRemotNumpadMainContainer_landscape: {
    position: "absolute", 
    height: 630,
    top: 100,
    right: 30,
    padding: 24,
    paddingBottom: 50,
    borderRadius: 20,
    maxWidth: 280,
    justifySelf: "center",
    alignSelf: "center",
    backgroundColor: COLORS.WHITE,

    shadowColor: "#000",
    shadowOffset: {
        width: 0,
        height: 0,
    },
    shadowOpacity: 0.4,
    shadowRadius: 14,

    elevation: 8,
  },

  
  tvRemoteMainContainerChildContainer_landscape: {
    width: "100%",
    alignSelf: "center",
  },
  tvRemoteSelectHeadingText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginVertical: 8
  },

  tvRemoteHeaderContainer_landscape: {
    display: "none",
  },
  
  tvRemoteButtonContainer_landscape: {
    backgroundColor: COLORS.SECONDARY_COLOR,
    borderRadius: 30,
    padding: 12,
    justifyContent: "center",
    alignItems: "center"
  },
  tvRemotePowerButtonContainer_landscape: {
    backgroundColor: COLORS.BACKGROUND_COLOR,
    borderRadius: 30,
    maxWidth: 48,
    padding: 12
  },

  tvRemoteSwitchButtonContainer_landscape: {
    backgroundColor: COLORS.SECONDARY_COLOR,
    borderRadius: 30,
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    marginTop: 16,
  },

  tvRemoteImagePowerButton_landscape: {
    padding: 7,
  },

  tvRemoteButton_landscape: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.SECONDARY_TEXT_COLOR,
  },
  tvRemoteImageButton_landscape: {

    height: 24,
    width: 24,
  },
  tvRemoteImageButtonArrow_landscape: {
    height: 24,
    width: 24,
    padding: 12
  },
  tvRemoteImageAddMinusButton_landscape: {
    tintColor: COLORS.WHITE,
    filter: "invert(1)",
    height: 24,
    width: 24,
  },
  tvRemotePowerButtonMainContainer_landscape: {
    height: 48,
    marginBottom: 16
  },

  tvRemoteTwoButtonContainer_landscape: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  tvRemoteSwitchButton_landscape: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    margin: 8,
  },
  tvRemoteSwitchButtonText_landscape: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    padding: 12,
  },
  tvRemoteImageOkButton_landscape: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    padding: 12,
  },
  tvRemoteImageArrowButton_landscape: {
    justifyContent: "center",
    alignItems: "center",
    padding: 12,
  },
  tvRemoteImageArrowOkButtonContainer_landscape: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  tvRemoteImageOkButtonContainer_landscape: {
    height: 112,
    width: 112,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: COLORS.SECONDARY_COLOR,
    borderRadius: 60
  },
  tvRemoteBottomButtonsContainer_landscape: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 16,
  },
  tvRemoteBottomButtonsContainerApple_landscape: {
    maxWidth: 50,
    justifySelf: "center",
    alignSelf: "center"
  },
  tvRemoteVolumeButtonContainer_landscape: {
    backgroundColor: COLORS.SECONDARY_COLOR,
    justifyContent: "center",
    alignitems: "center",
    borderRadius: 30,
    gap: 8,
  },
  tvRemoteVolumeButtonContainerText_landscape: {
    ...SECONDARY_FONT,
    color: COLORS.SECONDARY_TEXT_COLOR,
    textAlign: "center",
  },
  tvRemoteBottomCenterButtonsContainer_landscape: {
    justifyContent: "center",
    alignItems: "center",
    gap: 16
  },
  tvRemoteFilterPillContainer: {
    marginLeft: 30,
    paddingBottom: 20
  },

  tvRemoteFallbackContainer_landscape: {
    justifyContent: "center",
    gap: 16,
  },
  tvRemoteFallbackImage_landscape: {
    width: 200,
    height: 200,
    alignSelf: "center",
  },
  mediaDeviceListMainContainer: {
    gap: 20, 
    marginTop: 20, 
    flexDirection: "row", 
    flexWrap: "wrap",
  },
  mediaDeviceList_loader: {
    tintColor: COLORS.BLACK
  },
  mediaDeviceListContainer_loader: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    minHeight: 200,
  },
  mediaDeviceListContainer: {
    height: 135,
    width: 275,
    borderRadius: 10,
    backgroundColor: COLORS.WHITE,
    justifyContent: "center",
    alignItems: "center",
    
    shadowColor: "#000",
    shadowOffset: {
        width: 0,
        height: 0,
    },
    shadowOpacity: 0.2,
    shadowRadius: 8,

    elevation: 8,
  },
  mediaDeviceImageContainer: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: 10,
  },
  mediaDeviceTextContainer: {
    display: "none"
  },
  mediaDeviceText: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  tvChannelsMainContainer: {
    gap: 20, 
    marginTop: 20, 
    flexDirection: "row", 
    flexWrap: "wrap", 
    maxWidth: 600,
    width: "65%"
  },
  tvChannelsHeaderContainer: {
    marginTop: 10,
  },
  tvChannelsHeaderContainerTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  mediaTvHeaderContainer: {
  },
  mediaTvHeaderContainerTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },

  tvRemoteHighlightContainer_landscape: {

  },
  tvRemoteSwitchButtonActive_landscape: {

  },
  tvRemoteSwitchButtonTextActive_landscape: {

  },

  tvRemoteNumpadRowContainer_landscape: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 16,
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.10)"
  },
  tvRemoteNumpadContainer_landscape: {
    width: 216,
    maxWidth: 320,
    borderRadius: 12,
    backgroundColor: COLORS.WHITE,

    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.2,
    shadowRadius: 4,
  },
  tvRemoteButtonNumpadContainer_landscape: {
    display: "none",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 24,
  },
  tvRemoteContainerChildContainer_landscape: {
    maxWidth: "65%"
  },
  tvChannelsFilterItemContainer_landscape: {
    flex: 1
  },
  tvChannelsFilterContainer: {
    gap: 16,
  },
  tvChannelsFilterContainer_landscape: {
    gap: 16,
    flexDirection: "row",
  },
  tvRemoteNumpadRowButtonContainer_landscape: {
    padding: 16,
    width: "33.3%",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center"
  },
  tvRemoteNumpadRowButton_landscape: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center",
  },
  tvRemoteImagePlayPauseButton_landscape: {
    height: 16,
    width: 16,
  },
  tvRemoteNoTvTextContainer_landscape: {

  },
  tvRemoteNoTvText_landscape: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.SECONDARY_TEXT_COLOR,
  },


  /**
   * TV Remote
   */
  tvRemoteMainContainer_potrait: {

  },

  tvRemoteMainContainerChildContainer_potrait: {
    width: "100%",
    maxWidth: 450,
    alignSelf: "center",
  },

  tvRemoteHeaderContainer_potrait: {
    display: "none",
  },
  
  tvRemoteButtonContainer_potrait: {
    backgroundColor: COLORS.SECONDARY_COLOR,
    borderRadius: 30,
    padding: 12,
  },
  tvRemotePowerButtonContainer_potrait: {
    backgroundColor: COLORS.SECONDARY_COLOR,
    borderRadius: 30,
    maxWidth: 48,
    padding: 12
  },

  tvRemoteSwitchButtonContainer_potrait: {
    backgroundColor: COLORS.SECONDARY_COLOR,
    borderRadius: 30,
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    marginTop: 16,
  },

  tvRemoteImagePowerButton_potrait: {
    padding: 7,
  },

  tvRemoteButton_potrait: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.SECONDARY_TEXT_COLOR,
  },
  tvRemoteImageButton_potrait: {
    tintColor: COLORS.BLACK,
    filter: "invert(1)",
    height: 24,
    width: 24,
  },
  tvRemoteImageButtonArrow_potrait: {
    height: 24,
    width: 24,
    padding: 12
  },
  tvRemoteImageAddMinusButton_potrait: {
    height: 24,
    width: 24,
  },

  tvRemoteTwoButtonContainer_potrait: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 24,
  },
  tvRemoteSwitchButton_potrait: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    margin: 8,
  },
  tvRemoteSwitchButtonText_potrait: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.SECONDARY_TEXT_COLOR,
    padding: 12,
  },
  tvRemoteImageOkButton_potrait: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.SECONDARY_TEXT_COLOR,
    padding: 12,
  },
  tvRemoteImageArrowButton_potrait: {
    justifyContent: "center",
    alignItems: "center",
    padding: 12,
  },
  tvRemoteImageArrowOkButtonContainer_potrait: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  tvRemoteImageOkButtonContainer_potrait: {
    height: 112,
    width: 112,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: COLORS.SECONDARY_COLOR,
    borderRadius: 60
  },
  tvRemoteBottomButtonsContainer_potrait: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 16,
  },
  tvRemoteBottomButtonsContainerApple_potrait: {
    maxWidth: 50,
    justifySelf: "center",
    alignSelf: "center"
  },
  tvRemoteVolumeButtonContainer_potrait: {
    backgroundColor: COLORS.SECONDARY_COLOR,
    justifyContent: "center",
    alignitems: "center",
    borderRadius: 30,
    gap: 8,
  },
  tvRemoteVolumeButtonContainerText_potrait: {
    ...SECONDARY_FONT,
    color: COLORS.SECONDARY_TEXT_COLOR,
    textAlign: "center",
  },
  tvRemoteBottomCenterButtonsContainer_potrait: {
    justifyContent: "center",
    alignItems: "center",
    gap: 16
  },

  tvRemoteFallbackContainer_potrait: {
    justifyContent: "center",
    gap: 16,
  },
  tvRemoteFallbackImage_potrait: {
    width: 200,
    height: 200,
    alignSelf: "center",
  },

  tvRemoteFooterButtonContainer_potrait: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginVertical: 24,
    marginHorizontal: 16,
    paddingLeft: 0,
    paddingRight: 0,
    borderRadius: 30,
    backgroundColor: COLORS.SECONDARY_COLOR,

    width: "100%",
    maxWidth: 450,
    alignSelf: "center",
  },
  tvRemoteFooterActiveContainer_potrait: {
    backgroundColor: "transparent",
    padding: 8,
    borderRadius: 30,

    flex: 1,
  },
  tvRemoteFooterActiveButton_potrait: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.ACCENT_Text_COLOR,
    textAlign: "center"
  },
  tvRemoteFooterButtonItemContainer_potrait: {
    backgroundColor: "transparent",
    padding: 8,
    margin: 8,
    borderRadius: 30,
    flex: 1,
    width: 40
  },
  tvRemoteHighlightContainer_potrait: {
    backgroundColor: COLORS.ACCENT_COLOR,
    // padding: 8,
    borderRadius: 30,
    flex: 1,
    position: "absolute",
    height: 40,
    left: 0,
    marginHorizontal: 8,
  },

  tvRemoteSwitchButtonActive_potrait: {
    backgroundColor: COLORS.ACCENT_COLOR,
    borderRadius: 30,
  },
  tvRemoteSwitchButtonTextActive_potrait: {
    color: COLORS.ACCENT_Text_COLOR,
  },

  tvRemoteFooterButton_potrait: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center",
  },
  tvRemoteNumpadRowContainer_potrait: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 16,
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.10)"
  },
  tvRemoteNumpadContainer_potrait: {
    width: 345,
    maxWidth: 320,
    borderRadius: 12,
    backgroundColor: COLORS.WHITE,

    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.2,
    shadowRadius: 4,
  },
  tvRemoteButtonNumpadContainer_potrait: {
    justifyContent: "center",
    alignItems: "center",
    marginTop: 24,
  },
  tvChannelsFilterItemContainer_potrait: {
    flex: 1
  },
  tvChannelsFilterContainer_potrait: {
    gap: 16,
    marginBottom: 32,
    flexDirection: "row",
  },
  tvRemoteNumpadRowButtonContainer_potrait: {
    padding: 16,
    width: "33.3%",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center"
  },
  tvRemoteNumpadRowButton_potrait: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center",
  },
  tvRemoteImagePlayPauseButton_potrait: {
    height: 16,
    width: 16,
  },
  tvRemoteNoTvTextContainer_potrait: {

  },
  tvRemoteNoTvText_potrait: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.SECONDARY_TEXT_COLOR,
  },

  mediaDeviceListMainContainer_potrait: {
    gap: 20, 
    marginTop: 20,
    flexWrap: "wrap", 
    width: "100%",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",

  },
  mediaDeviceList_loader_potrait: {
    tintColor: COLORS.BLACK
  },
  mediaDeviceListContainer_loader_potrait: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  mediaDeviceListContainer_potrait: {
    height: 135,
    minWidth: 135,
    flex: 1,
    borderRadius: 10,
    
    shadowColor: "#000",
    shadowOffset: {
        width: 0,
        height: 0,
    },
    shadowOpacity: 0.2,
    shadowRadius: 8,

    elevation: 8,
  },
  mediaDeviceImageContainer_potrait: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: 10,
  },
  mediaDeviceTextContainer_potrait: {
    display: "none"
  },
  mediaDeviceText_potrait: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },


  /**
   * Guest Itinerary Details
   */

  guestItineraryWidgetViewAllTxt: {
    color: COLORS.PRIMARY_TEXT_COLOR
  },

  guestItineraryWidgetTitleText:{
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
  },
  guestItineraryWidgetSubTitleText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: "center",
    paddingVertical: 10
  },
  guestItineraryWidgetItemImageContainer: {
    height: 50,
    width: 50

  },
  guestItineraryWidgetItemImage: {
    objectFit: "cover",
    width: 50,
    height: 50,


  },
  guestItineraryWidgetTitleTextContainer:{
    width: "100%",
    paddingLeft: 10,
    paddingRight: 10,
    justifyContent: "center"
  },
  guestItineraryWidgetSubTitleText2: {
    paddingHorizontal: 17,
    textAlign: "center",
    paddingTop: 0,
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  guestItineraryViewAllButtonContainer: {
    marginVertical: 20,
  },

  

  guestItineraryWidgetRootContainer: {
    flex: 1,
    padding: 16,
    // maxHeight: 320,
  },
  guestItineraryWidgetTitleContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.BACKGROUND_COLOR,
    flexDirection: "column",
    // position: 'sticky',
    top: 0,
    left: 0,
    zIndex: 1,
    // height: 32,
    paddingVertical: 0,
    paddingHorizontal: 0
  },

  guestItineraryWidgetsWidgetContainer: {

  },
  guestItineraryWidgetHeaderTitle:{
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    marginTop: 20,
    marginBottom: 12,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  guestItineraryWidgetContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderLeftWidth: 5,
    borderLeftColor: COLORS.ACCENT_COLOR,
    paddingLeft: 12
  },
  guestItineraryWidgetImageStyle: {
    width: 72,
    height: 72,
  },
  guestItineraryWidgetImage: {
    width: "100%", 
    height: "100%"
  },
  guestItineraryWidgetTextContainer: {
    flex: 1,
    height: 72,
    justifyContent: "center"
  },
  guestItineraryWidgetTitle: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
    fontSize: 16,
    lineHeight: 24
  },
  guestItineraryWidgetDescription: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
  },
  guestItineraryWidgetArrow_container: {
    padding: 16
  },

  guestItineraryWidgetTitleViewAll: {
    display: 'none',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  guestItineraryWidgetTitleArrow: {

  },
  guestItineraryWidgetTitleArrow_container: {
    padding: 16,
    height: 48,
    width: 41
  },

  guestItineraryWidgetItemContainer: {
    flexDirection: "row",
    width: "75%"
  },


  guestItineraryDetails_timeDateContainer:{
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    marginHorizontal: 16,
    marginBottom: 8,
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.10)"
  },
  guestItineraryDetails_timeDateItem: {
    width: '50%',
    paddingVertical: 10
  },

  guestItineraryDetails_descriptionContainer: {
    display: 'flex',
    marginHorizontal: 16,
    marginBottom: 8,
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.10)"
  },
  guestItineraryDetails_description: {
    paddingVertical: 10
  },
  guestItinerary_details:{
    marginBottom: 8,
  },
  guestItinerary_detailItem: {
    display: 'flex',
    flexDirection: 'row',
    paddingVertical: 10,
    justifyContent: 'space-between',
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.10)"
  },


  /**
   * Multi Controller Widget
   */
  multiControllerWidgetMainContainer: {
    flex: 1,
    paddingHorizontal: 16,
    marginBottom: 16,
  },
  multiControllerWidgetContainer: {
    flex: 1,
    paddingVertical: 16,
    gap: 16,
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: COLORS.BACKGROUND_COLOR_SECONDARY,
    borderRadius: 8
  },

  multiControllerWidgetImageStyle: {
  },
  multiControllerWidgetImage: {
    height: 24,
    width: 24,
    objectFit: "contain"
  },
  multiControllerWidgetTitle: {
    ...FONT_SMALL,
    ...PRIMARY_FONT,
    textTransform: "uppercase", 
    color: COLORS.BACKGROUND_COLOR_SECONDARY_CONTRAST
  },
  multiControllerWidgetDescription: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_SECONDARY_CONTRAST,
  },


  /**
   * Room Controls
   */
  roomControlsMainContainer: {
    paddingBottom: 20,
  },
  roomControlsHeaderContainer: {
    display: "none"
  },
  roomControlsNoControlsText: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  roomControlsRetryContainer: {
    justifyContent: "center", 
    alignItems: "center",  
    marginTop: "20%"
  },
  roomControlsListItemContainer: {
    gap: 16
  },
  roomControlRetryButtonContainer: {
    maxWidth: "50%",
  },
  roomControlButtonContainer: {
    borderWidth: 1, 
    borderColor: COLORS.PRIMARY_TEXT_COLOR, 
    padding: 12, 
    borderRadius: 6,
  },
  roomControlButtonText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  roomControlSection: {
    marginTop: 20,
  },
  roomControlSectionTitle: {
    ...FONT_MEDIUM,
    ...PRIMARY_FONT,
    marginBottom: 10,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  roomControlItemContainer: {
  },
  roomControlItemTitle: {
    ...FONT_MEDIUM,
    ...PRIMARY_FONT,
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingVertical: 12
  },
  roomControlSwitchContainer: {
    gap: 8
  },
  roomControlFanSpeedContainer: {
    flexDirection: 'row',
  },
  roomControlMasterTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingBottom: 10
  },
  roomControlsItemLabelText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  roomControlSubItemTitle: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingBottom: 8
  },
  roomControlItemSubContainer: {
    flexDirection: "row", 
    flexWrap: "wrap",
    gap: 8
  },

  /**
   * Room Theme
   */
  roomThemeTitleContainer: {
    display: "none"
  },
  roomTheme_HeaderTitle: {
  },
  roomThemeItemContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    paddingBottom: 10,
  },

  roomThemeButtonContainer: {
    borderWidth: 1,
    borderColor: COLORS.SECONDARY_TEXT_COLOR,
    padding: 20,
    borderRadius: 10,
    marginBottom: 12,
    width: "48%",
  },

  roomThemeButtonContainerText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textAlign: "center",
    color: COLORS.SECONDARY_TEXT_COLOR,
  },


  /**
   * Room Temperature
   */
  roomTemperatureGradientColors: {
    gradientColor: [COLORS.SECONDARY_COLOR, COLORS.WHITE]
  },
  roomTemperatureDeviceContainer: {
    paddingVertical: 10,
    alignItems: 'center',
    borderRadius: 20,
  },
  roomTemperatureDevice: {
    backgroundColor: COLORS.SECONDARY_COLOR,
    paddingHorizontal: 20,
    paddingVertical: 8,
    marginBottom: 10,
    borderRadius: 20,
  },
  roomTemperatureDeviceContainerText: {
    ...FONT_MEDIUM,
    ...SECONDARY_FONT,
    color: COLORS.SECONDARY_TEXT_COLOR,
    textAlign: 'center',
  },
  roomTemperatureSwitchContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: "center",
    gap: 20,
  },
  roomTemperatureSwitchOnOffMainContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  roomTemperatureSwitchTopContainer: {
    backgroundColor: COLORS.SECONDARY_COLOR,
    padding: 12,
    borderTopRightRadius: 8,
    borderTopLeftRadius: 8
  },
  roomTemperatureSwitchBottomContainer: {
    backgroundColor: COLORS.SECONDARY_COLOR,
    padding: 12,
    borderBottomRightRadius: 8,
    borderBottomLeftRadius: 8
  },
  roomTemperatureSwitchOnContainer: {
    backgroundColor: COLORS.SECONDARY_COLOR,
    padding: 12,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
  },
  roomTemperatureSwitchOffContainer: {
    backgroundColor: COLORS.SECONDARY_COLOR,
    padding: 12,
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
  },
  roomTemperatureSwitchOnImage: {
    height: 24,
    width: 24
  },
  roomTemperatureSwitchOffImage: {
    height: 24,
    width: 24
  },


  roomTemperatureSwitchOnOffText: {
    ...FONT_MEDIUM,
    ...SECONDARY_FONT,
    color: COLORS.SECONDARY_TEXT_COLOR,
    textAlign: 'center',
  },
  roomTemperatureSwitchUnitContainer: {

  },


  roomTemperatureSliderText: {
    fontSize: 48, 
    color: COLORS.PRIMARY_TEXT_COLOR
  },

  roomTemperatureSliderContainer: {
    marginBottom: 140,
    marginTop: 40
  },

  // ── Room Temperature UI ──────────────────────────────

  roomTemperatureFullScreenContainer: {
    flex: 1,
    backgroundColor: COLORS.PRIMARY_COLOR,
  },
  roomTemperatureNoDataContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  roomTemperatureNoDataText: {
    ...SECONDARY_FONT,
    fontSize: 16,
    color: COLORS.DARK_GREY,
    textAlign: 'center',
  },
  roomTemperatureScrollContent: {
    flexGrow: 1,
    paddingHorizontal: 24,
    paddingBottom: 24,
    paddingTop: 24,
  },
  roomTemperatureScrollContentWithClose: {
    paddingTop: 72,
  },
  roomTemperatureHeading: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginBottom: 28,
  },
  // Row containing UNIT pill + FAN MODE options
  roomTemperatureControlsRow: {
    flexDirection: 'row',
    alignItems: "center", 
    justifyContent: "center",
    marginBottom: 40,
  },
  roomTemperatureUnitContainer: {
    alignItems: 'center',
    marginRight: 16,
  },
  roomTemperatureUnitPill: {
    flexDirection: 'row',
    borderRadius: 30,
    backgroundColor: COLORS.BACKGROUND_COLOR,
    overflow: 'hidden',
    marginBottom: 8,
    padding: 4,
  },
  roomTemperatureUnitButton: {
    width: 44,
    height: 44,
    borderRadius: 22,
    alignItems: 'center',
    justifyContent: 'center',
  },
  roomTemperatureUnitButtonActive: {
    backgroundColor: COLORS.ACCENT_COLOR,
  },
  roomTemperatureUnitButtonText: {
    ...SECONDARY_FONT,
    fontSize: 14,
    color: COLORS.DARK_GREY,
    fontWeight: '600',
  },
  roomTemperatureUnitButtonTextActive: {
    color: COLORS.WHITE,
    fontWeight: '600',
  },
  roomTemperatureControlLabel: {
    ...SECONDARY_FONT,
    fontSize: 10,
    letterSpacing: 1.5,
    color: COLORS.DARK_GREY,
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  roomTemperatureFanModeContainer: {
    alignItems: 'center',
  },
  roomTemperatureFanModeButton: {
    backgroundColor: COLORS.SECONDARY_COLOR,
    borderRadius: 30,
    paddingHorizontal: 24,
    paddingVertical: 10,
    minWidth: 90,
    alignItems: 'center',
    marginBottom: 8,
  },
  roomTemperatureFanModeText: {
    ...SECONDARY_FONT,
    fontSize: 14,
    color: COLORS.SECONDARY_TEXT_COLOR,
    fontWeight: '600',
  },
  roomTemperatureFanOptionsRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 8,
  },
  roomTemperatureFanOptionButton: {
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: '#CCCCCC',
    marginRight: 6,
    marginBottom: 6,
    alignItems: 'center',
    justifyContent: 'center',
  },
  roomTemperatureFanOptionButtonActive: {
    borderColor: COLORS.ACCENT_COLOR,
    backgroundColor: COLORS.ACCENT_COLOR,
  },
  roomTemperatureFanOptionText: {
    ...SECONDARY_FONT,
    fontSize: 12,
    color: COLORS.DARK_GREY,
    fontWeight: '500',
    textAlign: 'center',
  },
  roomTemperatureFanOptionTextActive: {
    color: COLORS.WHITE,
  },
  roomTemperatureTempSection: {
    alignItems: 'center',
    marginVertical: 16,
  },
  roomTemperatureSetToLabel: {
    ...SECONDARY_FONT,
    fontSize: 11,
    letterSpacing: 2,
    color: COLORS.DARK_GREY,
    textTransform: 'uppercase',
    marginBottom: 20,
  },
  roomTemperatureTempRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  roomTemperatureStepButton: {
    width: 60,
    height: 60,
    backgroundColor: "#F7F6F3",
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 16,
    borderWidth: 1, 
    borderColor: "#D5D0C3", 
    borderRadius: 5, 
  },
  roomTemperatureStepButtonText: {
    fontSize: 28,
    color: COLORS.SECONDARY_COLOR,
    lineHeight: 34,
  },
  roomTemperatureTempValueContainer: {
    minWidth: 160,
    alignItems: 'center',
  },
  roomTemperatureTempValueText: {
    ...PRIMARY_FONT,
    fontSize: 60,
    fontWeight: '200',
    color: COLORS.PRIMARY_TEXT_COLOR,
    letterSpacing: -1,
    lineHeight: 64,
  },
  roomTemperatureUnitSubLabel: {
    ...SECONDARY_FONT,
    fontSize: 10,
    letterSpacing: 2,
    color: COLORS.DARK_GREY,
    textTransform: 'uppercase',
    marginTop: 12,
  },
  roomTemperaturePowerRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 32,
  },
  roomTemperaturePowerButton: {
    paddingHorizontal: 36,
    paddingVertical: 14,
    borderRadius: 30,
    borderWidth: 1.5,
    borderColor: '#CCCCCC',
    marginHorizontal: 6,
  },
  roomTemperaturePowerButtonActive: {
    borderColor: COLORS.ACCENT_COLOR,
    backgroundColor: COLORS.ACCENT_COLOR,
  },
  roomTemperaturePowerButtonText: {
    ...SECONDARY_FONT,
    fontSize: 15,
    color: COLORS.DARK_GREY,
    fontWeight: '600',
    textAlign: 'center',
  },
  roomTemperaturePowerButtonTextActive: {
    color: COLORS.WHITE,
  },
  roomTemperatureRoomTabsWrapper: {
    paddingHorizontal: 24,
    paddingBottom: 24,
    paddingTop: 8,
  },
  roomTemperatureRoomTabsRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: COLORS.BACKGROUND_COLOR,
    borderRadius: 30,
    padding: 4,
    alignSelf: 'center',
  },
  roomTemperatureRoomTab: {
    paddingHorizontal: 24,
    paddingVertical: 12,
    borderRadius: 26,
  },
  roomTemperatureRoomTabActive: {
    backgroundColor: COLORS.ACCENT_COLOR,
  },
  roomTemperatureRoomTabText: {
    ...SECONDARY_FONT,
    fontSize: 14,
    color: COLORS.DARK_GREY,
  },
  roomTemperatureRoomTabTextActive: {
    ...SECONDARY_FONT,
    fontSize: 14,
    color: COLORS.WHITE,
    fontWeight: '600',
  },
  roomControlAcControlsButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderWidth: 1,
    borderColor: COLORS.PRIMARY_TEXT_COLOR,
    padding: 16,
    borderRadius: 8,
    marginBottom: 16,
  },
  roomControlAcControlsButtonText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  roomControlAcFullScreenOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: COLORS.PRIMARY_COLOR,
    zIndex: 100,
  },

  /**
 *
 * Banner WIDGET STYLE
 *
 */
  bannerWidgetMainContainer: {
    // flex: 1,
    paddingHorizontal: 16,
  },
  bannerWidgetsWidgetContainer: {
    flex: 1,
    flexDirection: "row",
    paddingVertical: 16,
    gap: 16,
    width: "100%",
    alignItems: "center",
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.10)"
  },
  bannerWidgetImageStyle: {
    width: 72,
    height: 72,
  },
  bannerWidgetImage: {
    width: "100%", 
    height: "100%",
    objectFit: 'cover'
  },
  bannerWidgetTextContainer: {
    flex: 1,
    minHeight: 72,
    maxHeight: 90,
    justifyContent: "center"
  },
  bannerWidgetTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
    fontSize: 16,
    lineHeight: 24
  },
  bannerWidgetDescription: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
  },
  bannerWidgetArrow_container: {
    padding: 16
  },

  /**
 *
 * Banner MULTIPLE WIDGET STYLE LANDSCAPE
 *
 */
  bannerWidgetMultipleMainContainer: {
    width: "100%",
    padding: 16,
    backgroundColor: COLORS.PRIMARY_COLOR,
  },
  bannerWidgetsMultipleWidgetContainer: {
    flex: 1,
    flexDirection: "row",
    gap: 16,
    width: "100%",
    alignItems: "center",
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.10)",

    paddingVertical: 20,
  },
  bannerWidgetMultipleImageStyle: {
    width: 72,
    height: 72,
  },
  bannerWidgetMultipleImage: {
    width: "100%", 
    height: "100%",
    objectFit: 'cover'
  },
  bannerWidgetMultipleTextContainer: {
    flex: 1,
    maxHeight: 90,
    justifyContent: "center"
  },
  bannerWidgetMultipleTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    minWidth: 145,
  },
  bannerWidgetMultipleDescription: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  bannerWidgetMultipleArrow_container: {
    padding: 16
  },
  bannerMultipleMultipleWidgetTitleText: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textWrap: "nowrap",
  },
  bannerMultipleMultipleWidgetDescriptionText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.SECONDARY_TEXT_COLOR,
    display: "none"
  },

/**
 * Spa booking - book4time
 */
  spaBookingHeaderImg: {
    height: 292,
    maxWidth: null,
    margin: null
  },

  spaBookingMakeReservationContianer: {
    paddingVertical: 8,
    paddingHorizontal: 32,
    marginBottom: 40,
    height: 56,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: COLORS.SECONDARY_COLOR,
  },
  spaBookingMakeReservation: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.SECONDARY_TEXT_COLOR,
    textTransform: "uppercase",
  },

  spaBookingMyReservationHeading: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
  },

  spaBookingNoReservationErrorContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 24,
    marginTop: 16,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.10)",
  },
  spaBookingNoReservationError: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  spaBookingItemContainer: {
    height: "auto",
  },

  spaBookingMyReservationHeadingContainer: {
    marginTop: 16
  },
  spaBookingMyReservationItemContainer: {
    marginBottom: 16, 
    borderRadius: 12, 
    overflow: 'hidden'
  },
  spaBookingHeadingDayText: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    paddingHorizontal: 0, 
    paddingVertical: 10, 
    letterSpacing: 0.5
  },
  spaBookingDayContainer: {
    flexDirection: "row", 
    alignItems: "center", 
    justifyContent: "space-between", 
    gap: 12,
    paddingVertical: 6, 
    borderBottomWidth: 1, 
    borderBottomColor: 'rgba(0,0,0,0.06)'
  },
  spaBookingDayServiceContainer: {
    flex: 1, 
    gap: 4
  },
  spaBookingDayServiceName: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  spaBookingDayServiceDate: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  spaBookingDayButtonContainer: {
    flexDirection: 'row', 
    alignItems: 'center',
  },
  spaBookingDayCancelButton: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    paddingHorizontal: 10, 
    paddingVertical: 4,
  },
  spaBookingDayUpdateButtonContainer: {
    padding: 8, 
    borderRadius: 8,
  },
  spaBookingDayCancelButtonContainer: {
  },
  spaBookingCancelledButton: {
    tintColor: COLORS.PRIMARY_TEXT_COLOR,
    filter: "invert(1)"
  },


  // Spa Booking 1a
  spaBookingMainContainerChildContainer: {
    marginBottom: 180,
  },

  spaBookingFitlerContainer: {
    display: "flex",
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    marginBottom: 0
  },
  spaBookingFitlerButtonContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderBottomWidth: 0.5,
    borderColor: "rgba(0, 0, 0, 0.10)"
  },
  spaBookingFitlerButtonText: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  spaBookingFitlerButtonContainerSelected: {
    borderBottomWidth: 2,
    borderColor: COLORS.ACCENT_COLOR
  },
  spaBookingFitlerButtonTextSelected: {
    color: COLORS.ACCENT_COLOR
  },
  spaBookingHeaderTitleImage: {
    height: 24,
    width: 24,
  },
  spaBookingEditButton: {
    height: 20,
    width: 20,
    objectFit: "cover"
  },
  spaBookingNextButtonContainer: {
    bottom: 0,
     width: '100%',
     padding: 16,
     backgroundColor: COLORS.BACKGROUND_COLOR,
     gap: 10,
  },


  spaBooking1aListItemName: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingTop: 40,
    paddingBottom: 12,
    textAlign: "center",
    textTransform: "uppercase"
  },
  spaBooking1aOnlineListItemDetailsName: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBooking1aOnlineListItemDetailsDescription: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  spaBooking1aOnlineListItem: {
    display: "flex",
    // justifyContent: "center",
    flexDirection: "row",
    gap: 16,

  },
  spaBooking1aOnlineListItemCheckbox: {
    borderRadius: 10,
  },
  spaBooking1aOnlineListItemDetails: {
    width: "100%",
    gap: 8,
    height: "auto"
  },
  spaBooking1aOnlineListItemDetailsContainer: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  spaBooking1aOfflineListItem: {
    height: "auto"
  },
  spaBooking1aListItemElseContainer: {
    height: "auto"
  },

  spaBooking1aOnlineListItemDetailsMinutes: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBooking1aOnlineListItemDetailsPrice: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  spaBooking1aOfflineListItemName: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    marginBottom: 8,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBooking1aOfflineListItemDescription: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    marginBottom: 8,
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingBottom: 8,
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.10)"
  },

  spaBooking1aOfflineListItemContactLabel: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    marginBottom: 8,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBooking1aOfflineListItemDetails: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  spaBooking1aOfflineListItemDetailsContainer: {
    height: "auto"
  },


  // 2a
  spaBookingTopContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 24,
  },
  spaBookingDurationContainer: {
    gap: 8
  },
  spaBookingBaseContainer: {
    gap: 8,
  },
  spaBookingDurationTtitleText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    // marginBottom: 8,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBookingBasePriceTitleText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    // marginBottom: 8,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBookingBasePriceText: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBookingDurationText: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBookingAddOnListHeading: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    // width: 120,
    textTransform: "uppercase"
  },
  spaBookingAddOnListSubHeading: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginVertical: 12,
  },
  spaBookingAddOnListItemAddonsContainer: {
    display: "flex",
    flexDirection: "row",
    gap: 16,
  },
  spaBookingAddOnListItemAddonsContainerName: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    width: "100%",
  },
  spaBookingAddOnListItemAddonsContainerPrice: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    width: 120
  },
  spaBooking2aTherapistContainerTitle: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    width: 120,
    textTransform: "uppercase"
  },
  spaBookingDataContainerLabel: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    // width: 120,
    textTransform: "uppercase"
  },
  spaBooking2aTherapistContainer: {
    marginTop: 24
  },  

  spaBookingDateContainer: {
    marginTop: 24,
  },
  spaBookingDropdownContainer: {
    display: "none",
    marginTop: 24
  },
  spaBookingTechnicalDataTitle:{
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    // width: 120,
    textTransform: "uppercase"
  },
  spaBookingTechnicalDataListItemStartime:{
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBookingTechnicalDataListItemTechnicianName:{
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    display: "none"
  },

  // 2c
  spaBooking2cInputContainer: {
    gap: 12
  },
  spaBookingDetailsTitle: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    display: "none"
  },
  spaBookingSummaryListItem: {
    justifyContent: "space-between"
  },
  spaBookingSummaryListItemLeftText: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    maxWidth: "45%",
  },
  spaBookingSummaryListItemRightText: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    width: "50%"
  },

  spaBookingTechnicalDetailsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  spaBookingTechnicalDetailsTimeContainer: {
    width: "50%",
    gap: 8

  },
  spaBookingTechnicalDetailsTimeTitle: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBookingTechnicalDetailsTimeText: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  // spa success
  spaBookingSuccessText: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center"
  },



  /**
 *
 * Multiple LARGE WIGDET
 *
 */
  multipleLargeWidgetContainer: {
    backgroundColor: COLORS.PRIMARY_COLOR,
    paddingLeft: 16,
    paddingVertical: 24,
    gap: 16,
  },
  multipleLargeWidgetTitleContainer: {
    display: 'flex',
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
    justifyContent: "space-between",
    paddingRight: 16
  },
  multipleLargeWidgetTitleText: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    width: "100%",
  },
  multipleLargeWidgetTextContainer:{
    maxWidth: "80%",
    gap: 8
  },
  multipleLargeWidgetDescriptionText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR
  },

  multipleLargeWidgetViewAllTxt: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  multipleLargeWidget_MainWidgetsContainer: {
    display: "flex",
    gap: 16,
    alignItems: "flex-start",
    paddingRight: 16,
  },
  multipleLargeWidget_WidgetsContainer: {
    display: "flex",
    flexDirection: "column",
    width: 175,
    gap: 16,
    alignSelf: "stretch"
  },
  multipleLargeWidget_WidgetsImg: {
    width: "100%",
    height: 260,
    alignSelf: "stretch",
    objectFit: "cover"
  },
  multipleLargeWidget_WidgetsTitleContainer: {
    position: "absolute",
    bottom: 0,
    padding: 16,
    gap: 10,

    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignSelf: "stretch"
  },
  multipleLargeWidget_ScrollTrack: {
    display: "none",
    height: 4,
    backgroundColor: COLORS.SECONDARY_TEXT_COLOR,
    opacity: 0.5,
    borderRadius: 4,
    marginRight: 16,
    overflow: "hidden"
  },
  multipleLargeWidget_ScrollThumb: {
    height: 4,
    backgroundColor: COLORS.SECONDARY_COLOR,
    borderRadius: 4,
  },

  activitiesCreateBookingTimeSlotsItemText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  activitiesCreateBookingSelectedEventQuantity: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  multipleLargeWidget_WidgetsTitleText: {
    width: "100%",
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.WHITE
  },
  multipleLargeWidget_WidgetsSubTitleText: {
    width: "100%",
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.WHITE
  },
  multipleLargeWidget_WidgetsButtonContainer: {
    display: "flex",
    justifyContent: "center",
    paddingVertical: 4,

    height: 22,
    borderBottomWidth: 1,
    borderBottomColor: COLORS.ACCENT_COLOR,
    width: "fit-content",
  },
  multipleLargeWidget_WidgetsButtonContainerText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.ACCENT_COLOR
  },
  multipleLargeWidget_WidgetsButtonContainerTextArrow: {
    height: 8,
    width: 25,
  },

  /* MULTIPLE SMALL WIDGET */
  multipleSmallWidgetContainer: {
    backgroundColor: COLORS.BACKGROUND_COLOR,
    paddingLeft: 16,
    paddingVertical: 24,
    gap: 16,
  },
  multipleSmallWidgetTitleContainer: {
    display: 'flex',
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
    justifyContent: "space-between",
    paddingRight: 16,
  },
  multipleSmallWidgetTitleText: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textWrap: "nowrap",
  },
  multipleSmallWidgetViewAllTxt: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.SECONDARY_TEXT_COLOR,
    display: "none",
  },
  multipleSmallWidget_MainWidgetsContainer: {
    display: "flex",
    alignItems: "flex-start",
    paddingRight: 16,
    gap: 8,
    flexWrap: "wrap",
    maxWidth: 700
  },
  multipleSmallWidgetTitleTextContainer: {
    gap: 8,
  },
  multipleSmallWidgetDescriptionText:{
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    colors: COLORS.PRIMARY_TEXT_COLOR,
  },
  multipleSmallWidget_WidgetsContainer: {
    display: "flex",
    flexDirection: "column",
    width: 219,
    height: 133,
    gap: 16,
    alignSelf: "stretch",
  },
  multipleSmallWidget_WidgetsImg: {
    width: "100%",
    height: "100%",
    alignSelf: "stretch",
    borderRadius: 5
  },
  multipleSmallWidget_WidgetsTitleContainer: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    gap: 4,
    alignSelf: "stretch",
    position: "absolute",
    bottom: 0,
    padding: 16,
  },
  multipleSmallWidget_WidgetsTitleText: {
    width: "100%",
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.SECONDARY_TEXT_COLOR,
  },
  multipleSmallWidget_WidgetsSubTitleText: {
    width: "100%",
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.SECONDARY_TEXT_COLOR
  },
  multipleSmallWidget_WidgetsButtonContainer: {
  },
  multipleSmallWidget_WidgetsButtonContainerText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.SECONDARY_TEXT_COLOR
  },


   /**
   * Small Icon Multiple Widget
   */
  smallIconMultipleWidgetContainer: {
    width: "100%",
    paddingHorizontal: 16,
    paddingVertical: 24,
  },
  smallIconMultipleWidgetTitleContainer: {
    display: "none",
  },
  smallIconMultipleWidgetItemsMainContainer: {
    flexDirection: "row", 
    flexWrap: "wrap",
    borderRadius: 5
  },
  smallIconMultipleWidgetTitleTextContainer: {
    gap: 8
  },
   smallIconMultipleWidgetTitleText: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textWrap: "nowrap",
  },
  smallIconMultipleWidgetDescriptionText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    colors: COLORS.PRIMARY_TEXT_COLOR,
  },
  smallIconMultipleWidget_WidgetsContainer: {
    flex: 1,
    alignSelf: "stretch",
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 24,
    paddingHorizontal: 8,
    gap: 6,
    height: 88,
    minWidth: "33.3%",
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.2)",
  },
  smallIconMultipleWidget_WidgetsImg: {
    width: 24,
    height: 24,
    alignSelf: "center",
    justifySelf: "center",
  },
  smallIconMultipleWidget_WidgetsTitleContainer: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    gap: 6,
    alignSelf: "stretch"
  },
  smallIconMultipleWidget_WidgetsTitleText: {
    width: "100%",
    ...PRIMARY_FONT,
    ...FONT_XSMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: "center"
  },
  smallIconMultipleWidget_WidgetsButtonContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: 'center',
    height: 48,
    width: "50%",
    paddingHorizontal: 24,
    paddingVertical: 8,
    borderWidth: 1,
    borderColor: COLORS.SECONDARY_TEXT_COLOR
  },
  smallIconMultipleWidget_WidgetsButtonContainerText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.SECONDARY_TEXT_COLOR
  },

  /** 
   * iFrameViewer
  */

  iFrameRootContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
    overflow: 'hidden',
  },
  iFrameMainContainer: {
    flex: 1,
    overflow: "hidden",
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
    overflow: "hidden",
    backgroundColor: COLORS.BACKGROUND_COLOR,
    flex: 1,
    paddingHorizontal: 16
  },
  iFrameMainContainerChildContainer: {
    height: "100%",
    paddingHorizontal: 0,
  },

  webViewMainContainerChildContainer: {
    flex: 1,
  },
  iFrameHeaderContainer: {
    display: "none"
  },

  /** 
   * iFrameViewer Open Default
  */

  iFrameRendererHomeMainContainer: {
    zIndex: 1000,
    overflow: 'hidden',
    minHeight: 300
  },

  iFrameRendererHomeMainContainerChildContainer: {
    width: '100%',
    height: '100%',
    border: 'none',
  },

  webViewHomeMainContainerChildContainer: {
    flex: 1,
  },

  /** 
   * iFrameViewer Open Default
  */

  iFrameRendererHomeMainContainer_landscape: {
    zIndex: 1000,
    overflow: 'hidden',
    minHeight: 300
  },

  iFrameRendererHomeMainContainerChildContainer_landscape: {
    width: '100%',
    height: '100%',
    border: 'none',
  },

  webViewHomeMainContainerChildContainer_landscape: {
    flex: 1,
  },


  /**
   *
   * Sub Widget List View
   *
   */
  subwidgetListRootContainer: {

  },
  subwidgetListMainContainer: {

  },
  subwidgetListHeaderContainer: {

  },
  subwidgetListHeaderImg: {

  },
  subwidgetListHeaderTitleContainer: {

  },
  subwidgetListHeaderTitle: {

  },
  subwidgetListHeaderSubTitle: {

  },
  subwidgetListMainContainerChildContainer: {

  },
  subwidgetList_itemContainer: {

  },
  subwidgetList_itemContainer_image: {

  },
  subwidgetList_itemContainer_textContainer: {

  },
  subwidgetList_itemContainer_textContainer_title: {

  },
  subwidgetList_itemContainer_textContainer_subtitle: {

  },
  subwidgetList_itemContainer_arrow: {

  },

  /**
   * Client Config Change Modal
   */


  changeConfigModalMainContainer: {
    gap: 16,
  },



  /**
   *
   * HEADER
   *
   */
  safeArea: {
    paddingTop: Platform.OS === "android" ? StatusBar.currentHeight : 0,
  },
  headerContainer: {
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  headerContainerWithBack: {

  },
  headerContainerInner: {
    display: "flex",
    flexDirection: "row",
    height: 56,
    width: "100%",
    justifyContent: 'center',
    alignItems: "center",
    gap: 8,
    padding: 8,
  },
  headerContainerInnerCompLeft: {
    display: "flex",
    height: 32,
    justifyContent: "center",
    alignItems: "flex-start",
    gap: 4,
    paddingHorizontal: 8,
    flex: 1
  },
  backIconContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  backIcon: {
    display: "flex",
    height: 18,
    width: 18,
    justifyContent: "center",
    alignItems: 'center',
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  backText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  locationIconContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  locationIcon: {
    display: "flex",
    height: 18,
    width: 18,
    justifyContent: "center",
    alignItems: 'center',
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  locationText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  headerContainerLogoContainer:{

  },
  headerContainerLogo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: "center",
    width: 118,
    height: 32
  },
  headerContainerInnerCompRight: {
    display: "flex",
    height: 32,
    justifyContent: "center",
    alignItems: "flex-end",
    gap: 4,
    paddingHorizontal: 8,
    flex: 1
  },

  headerBackContainer_background_gradient: {

  },

  notificationIcon: {
    display: "flex",
    height: 20,
    width: 20,
    justifyContent: "center",
    alignItems: 'center',
    tintColor: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  notificationicon_countcontainer: {
    display: "flex",
    position: "absolute",
    top: -12,
    right: -10,
    backgroundColor: COLORS.BLACK,
    width: 24,
    height: 24,
    borderRadius: 12,
    justifyContent: "center",
    alignitems: "center"
  },
  notificationicon_countcontainer_text: {
    color: COLORS.WHITE,
    textAlign: "center"
  },
  notificationicon_countcontainer_unread: {
    display: "flex",
    position: "absolute",
    top: -12,
    right: -12,
    backgroundColor: "#DC4538",
    width: 24,
    height: 24,
    borderRadius: 12,
    justifyContent: "center",
    alignitems: "center"
  },
  notificationicon_countcontainer_unread_text: {
    color: COLORS.WHITE,
    textAlign: "center"
  },



  /* buttons */

  footer_button_container: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    gap: 16,
    padding: 24,
    alignItems: "flex-start",
    backgroundColor: COLORS.PRIMARY_COLOR
  },


  primaryBtn: {
    backgroundColor: COLORS.SECONDARY_COLOR,
    display: "flex",
    flexDirection: "row",
    minHeight: 56,
    width: '100%',
    gap: 8,
    paddingVertical: 8,
    paddingHorizontal: 32,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 10,

    elevation: 2,

    // iOS shadow styles
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.2,
    shadowRadius: 4,
  },
  primaryBtnTxt: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textTransform: 'uppercase',
    color: COLORS.SECONDARY_TEXT_COLOR,
    margin: "auto",
    textAlign: "center"
  },
  primaryBtn_loader: {

  },

  secondaryBtn: {
    backgroundColor: COLORS.PRIMARY_COLOR,
    display: "flex",
    flexDirection: "row",
    minHeight: 56,
    width: '100%',
    gap: 8,
    paddingVertical: 8,
    paddingHorizontal: 32,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 0.5,
    borderColor: COLORS.PRIMARY_TEXT_COLOR,
    borderRadius: 10,

    elevation: 0.5,
    // iOS shadow styles
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },
  secondaryBtnTxt: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textTransform: 'uppercase',
    color: COLORS.PRIMARY_TEXT_COLOR,
    margin: "auto",
    textAlign: "center"
  },

  tertiaryBtn: {
    background: "transparent",
    display: "flex",
    flexDirection: "row",
    minHeight: 56,
    width: '100%',
    gap: 8,
    paddingVertical: 8,
    paddingHorizontal: 32,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1.5,
    borderColor: COLORS.WHITE,
    borderRadius: 10,

    elevation: 0.5,
    // iOS shadow styles
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },
  tertiaryBtnTxt: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textTransform: "uppercase",
    color: COLORS.WHITE,
    margin: "auto",
    textAlign: "center"
  },

  appleWalletBtn: {
    backgroundColor: COLORS.BLACK,
    display: "flex",
    flexDirection: "row",
    minHeight: 56,
    width: 256,
    marginHorizontal: "auto",
    gap: 8,
    paddingVertical: 8,
    paddingHorizontal: 16,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 0.5,
    borderColor: COLORS.PRIMARY_TEXT_COLOR,
    borderRadius: 10,

    elevation: 0.5,
    // iOS shadow styles
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },
  appleWalletBtnLogo: {
    width: 46, 
    height: 33, 
    resizeMode: "contain"
  },
  appleWalletBtnTxt: {
    color: COLORS.WHITE,
    fontFamily: "SF Pro",
    fontSize: 19,
    fontWeight: 400,
    textAlign: "center",
    margin: "auto"
  },


  /* Cross Button */

  crossOverContainer_Container: {
    position: 'absolute',
    top: 0,
    width: '100%',
    zIndex: 1,
  },
  crossOverContaniner_Cross: {
    borderRadius: 50,
    backgroundColor: COLORS.BLACK,
    padding: 4,
    marginRight: 16,
    alignSelf: 'flex-end',
    marginTop: 10,
  },
  crossOverContaniner_loader: {
    tintColor: COLORS.BLACK
  },


  /* Slider Pressable */
  customSliderContainer: {
    width: "100%",
    height: 50,
    backgroundColor: COLORS.SECONDARY_COLOR,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    cursor: "pointer",
  },
  customSliderFill: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    zIndex: 10,
    backgroundColor: COLORS.ACCENT_COLOR,
    justifyContent: "center",
    alignItems: 'center'
  },
  customSliderFillDisabled: {
    backgroundColor: COLORS.LIGHT_GREY
  },
  customSliderFillAnimated: {
    backgroundColor: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  customSliderFillAnimatedDisabled: {
    backgroundColor: COLORS.DARK_GREY
  },
  customSliderText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.SECONDARY_TEXT_COLOR,
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  customSliderTextBackdrop: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.SECONDARY_TEXT_COLOR,
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  customSliderTextBackdropDisabled: {
    color: COLORS.WHITE
  },
  customSliderThumb: {
    zIndex: 100,
    width: 50,
    height: 50,
    borderRadius: 10,
    backgroundColor: COLORS.WHITE,
    position: 'absolute',
    left: 0,
    top: 0,
    justifyContent: 'center',
    alignItems: 'center',

    elevation: 4,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 2,
  },
  customSliderArrowIcon: {
    width: 24,
    height: 12,
    objectFit: "contain"
  },


  /* Chip */
  chipContainer: {
    width: 200,
    maxWidth: 250,
    height: 40,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    margin: "auto",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
  },

  chipContainerText: {
    ...FONT_XSMALL,
    ...SECONDARY_FONT,
    color: COLORS.WHITE,
    textAlign: "center"
  },


  /**
*
* DATA FETCHING VIEW
*
*/
  overlayContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    gap: 24,
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10000,
  },
  overlayContainer_loader: {

  },
  overlayContainer_message: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.WHITE,
  },

  /** Adhoc */
  adhocMainContainerChildContainer: {
    marginBottom: 160,
  },
  adhocListElementHeaderContainer: {
    alignItems: 'center',
    paddingTop: 36,
    paddingBottom: 28,
    paddingHorizontal: 24,
    backgroundColor: COLORS.WHITE,
  },
  adhocListElementHeaderImage: {
    width: '100%',
    height: 220,
    objectFit: 'cover',
  },
  adhocOfferListItemHeaderContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    paddingVertical: 20,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: "rgba(0, 0, 0, 0.10)",
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  adhocOfferListItemContainer: {
    flexDirection: 'column',
    paddingHorizontal: 20,
    paddingVertical: 20,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: "rgba(0, 0, 0, 0.10)",
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  adhocNor1ListItemContainer: {
    flexDirection: 'column',
    paddingVertical: 20,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: "rgba(0, 0, 0, 0.10)",
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  adhocOfferListItemSubHeaderContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  adhocOfferListItemSubHeaderImage: {
    width: 130,
    height: 130,
    resizeMode: 'cover',
    borderRadius: 0,
    marginRight: 16,
    flexShrink: 0,
  },
  adhocOfferListItemHeaderTitleText: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  adhocOfferListItemHeaderSubTitleText: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  adhocOfferListItemMainHeaderTitleText: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  adhocOfferListItemMainHeaderSubTitleText: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  adhocOfferListItemHeaderTextContainer: {
    flex: 1,
    paddingTop: 2,
    minWidth: 0,
  },
  adhocOfferListItemOfferControlsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 8,
  },
  adhocOfferListItemOfferControlsPrice: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    letterSpacing: 0.5,
  },
  adhocOfferListButtonsContainer: {
    flexDirection: 'row',
    maxWidth: 120
  },
  adhocOfferListButtons: {
    minHeight: 35
  },
  adhocOfferListButtonsText: {
  },
  adhocOfferListButtonsSecondary: {
  },
  adhocOfferListButtonsSecondaryText: {
  },

  footerButtonContainer: {
    backgroundColor: COLORS.BACKGROUND_COLOR,
    position: "absolute", 
    bottom: 0, 
    width: "100%", 
    padding: 16,
    gap: 8
  },

  /* Input */

  textContainer: {
    gap: 8
  },
  input: {
    height: 56,
    padding: 16,
    width: "100%",
    color: COLORS.PRIMARY_TEXT_COLOR,
    borderWidth: 0.5,
    borderRadius: 10,
    borderColor: COLORS.PRIMARY_TEXT_COLOR,
    backgroundColor: COLORS.PRIMARY_COLOR,
    selectionColor: COLORS.ACCENT_COLOR,
    outlineWidth: 0,
    elevation: 0.5,
    // iOS shadow styles
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.1,
    shadowRadius: 6,
  },
  label: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textTransform: "capitalize",
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  textValue: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR
  },

  errorText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: 'red',
  },

  /* Required Text */
  requiredText: {
    color: 'red',
  },


  /* Dropdown */

  dropdownMaincontainer: {
    display: "flex",
    width: "100%",
    gap: 8,
    zIndex: 100
  },


  /* Dropdown - web */

  dropdown_web: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    width: "100%",
    minHeight: 56,
    padding: 16,
    borderWidth: 0.5,
    borderRadius: 10,
    borderColor: COLORS.PRIMARY_TEXT_COLOR,
    backgroundColor: COLORS.PRIMARY_COLOR,
  },

  dropdown_web_container: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    lineHeight: null,
    color: COLORS.PRIMARY_TEXT_COLOR,
    backgroundColor: COLORS.PRIMARY_COLOR,
  },
  dropdown_web_container_selected: {
    backgroundColor: "#F6F7F8",
    borderRadius: 10,
  },

  /* Dropdown - native */
  dropdown: {
    width: "100%",
    minHeight: 56,
    padding: 16,
    borderWidth: 0.5,
    borderRadius: 10,
    borderColor: COLORS.PRIMARY_TEXT_COLOR,
    backgroundColor: COLORS.PRIMARY_COLOR,
  },
  dropdown_container: {
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderRadius: 10,
  },
  dropdown_placeholder: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: "gray",
  },
  dropdown_selectedTextStyle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  dropdown_headerContainer: {
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderRadius: 10,
    paddingVertical: 8,
    paddingHorizontal: 10,
  },
  dropdown_headerText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    fontWeight: "bold",
  },
  dropdown_itemContainerStyle: {
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderRadius: 10,
    paddingVertical: 4,
    paddingHorizontal: 10,
  },
  dropdown_itemTextStyle: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  dropdown_inputsearchstyle: {
    backgroundColor: COLORS.PRIMARY_COLOR,
    color: COLORS.PRIMARY_TEXT_COLOR,
    borderRadius: 10
  },


  /**
   * Custom Drawer
   */
  drawerMaincontainer: {
    width: "100%",
  },
  drawerHeaderContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 16,
  },
  drawerHeaderTextContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flexShrink: 1,
    gap: 12,
  },
  drawerHeaderTitle: {
    ...FONT_MEDIUM,
    ...PRIMARY_FONT,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  drawerWarningBadge: {
    backgroundColor: COLORS.BACKGROUND_COLOR,
    borderRadius: 20,
    paddingHorizontal: 14,
    paddingVertical: 5,
  },
  drawerWarningText: {
    ...FONT_SMALL,
    ...PRIMARY_FONT,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  drawerToggleIcon: {

  },
  drawerDivider: {
    height: StyleSheet.hairlineWidth,
    backgroundColor: COLORS.SECONDARY_COLOR,
  },
  drawerOptionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingBottom: 12,
    borderBottomWidth: 0.5,
    borderColor: "rgba(0,0,0,0.2)",
    marginTop: 12,
    gap: 8,
  },
  drawerRadio: {
    width: 20,
    height: 20,
    borderWidth: 1,
    borderColor: 'grey',
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
  },
  drawerRadioSelected: {
    backgroundColor: COLORS.SECONDARY_COLOR,
  },
  drawerOptionLabel: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textTransform: "capitalize",
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  drawerRowDivider: {
    height: StyleSheet.hairlineWidth,
    backgroundColor: COLORS.SECONDARY_COLOR,
  },


  /* Pagination */
  paginationContainer: {
    display: "flex",
    flexDirection: "row",
    height: 48,
    justifyContent: "center",
    alignItems: "center",
    gap: 6,
    alignSelf: "stretch"
  },
  paginationDot: {
    width: 12,
    height: 12,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: COLORS.SECONDARY_COLOR
  },
  paginationActiveDot: {
    backgroundColor: COLORS.SECONDARY_COLOR
  },


  /* Custom modal */
  customModalContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: "100%",
    zIndex: 2
  },
  customModalInnerContainer: {
    flex: 1,
    width: "100%",
    margin: "auto",
    marginHorizontal: "auto",
    justifyContent: "flex-end",
    maxWidth: GENERAL_MAX_WIDTH
  },
  customModalInnerContainer_landscape: {
    flex: 1,
    margin: "auto",
    marginHorizontal: "auto",
    justifyContent: "center",
    justifySelf: "flex-end",
    alignSelf: "flex-end",
    maxWidth: GENERAL_MAX_WIDTH
  },
  customModalInnerContainerRightLandscape: {
    height: "100%",
    margin: null,
    justifyContent: "flex-end",
    marginHorizontal: null
  },
  modalOverlay: {
    flex: 1,
    justifyContent: "flex-end",
  },

  /* Custom modal landscape */
  customModalContainer_landscape: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 2,
    flex: 1,
    width: "50%",
    justifyContent: 'flex-end',
    paddingTop: 0,
    paddingBottom: 24,
    gap: 24,
  },

  /* Custom Overlay */
  customOverlayContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    gap: 24,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10000,
  },


  /* Date picker modal */
  datePickerModaContainer: {
    flex: 1,
    width: "100%",
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: "auto",
  },
  datePickerWrapper: {
    backgroundColor: COLORS.BACKGROUND_COLOR,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    paddingBottom: 24,
    width: '100%',
    maxWidth: GENERAL_MAX_WIDTH,
  },
  datePickerWrapper_child: {
    maxWidth: 450,
    marginHorizontal: "auto"
  },
  datePickerWrapper_child_innerContainer: {
    backgroundColor: COLORS.BACKGROUND_COLOR,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  DateTimePicker_primaryTextStyle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  DateTimePicker_secondaryTextStyle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  DateTimePicker_selectedTextStyle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    backgroundColor: COLORS.SECONDARY_COLOR,
    color: COLORS.SECONDARY_TEXT_COLOR
  },


  /* Flash Message */
  flashMessageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 56,
    gap: 8
  },
  flashMessageContainerDefault: {
    backgroundColor: COLORS.PRIMARY_COLOR
  },
  flashMessageContainerSuccess: {

  },
  flashMessageContainerError: {

  },

  flashMessageContainer_text: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM
  },
  flashMessageContainer_textDefault: {
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  flashMessageContainer_textSuccess: {

  },
  flashMessageContainer_textError: {

  },

  flashMessageContainer_title: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM
  },
  flashMessageContainer_titleDefault: {
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  flashMessageContainer_titleSuccess: {

  },
  flashMessageContainer_titleError: {

  },

  /* Auto Login Success Modal */
  autoLoginCardContainer : {
    flex: 1,
    width: "100%",
    maxHeight: 400,
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingHorizontal: 16,
    paddingVertical: 40,
    flexDirection: "column",
    justifyContent: "center",
    gap: 8
  },
  autoLoginSuccessContainer: {
    display: 'none'
  },
  autoLoginCardHeader: {
  },
  autoLoginCardHeaderText: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    textAlign: "center",
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  autoLoginCardBodyLoginText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: "center",
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  autoLoginGenericDoorkeyText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: "center",
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginVertical: 10,
  },
  autoLoginGenericDoorkeyImage: {
    width: 20,
    height: 20,
    marginHorizontal: 5,
    resizeMode: 'contain',
  },
  autoLoginCardBody: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    paddingVertical: 10,
    gap: 10,
  },
  autoLoginCardBodyTextContainer: {
    flex: 1,
    marginTop: 0,
  },
  autoLoginSuccessContainerBackgroundImg: {
    width: 50,
    height: 50,
    filter: "invert(1)",
    tintColor: COLORS.PRIMARY_TEXT_COLOR,
    resizeMode: 'contain',
    marginLeft: 10,
  },
  



  /* Info Modal Container */

  infoModalContainer: {
    display: "flex",
    width: "100%",
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    padding: 24,
    flexDirection: "column",
    justifyContent: "center",
    gap: 8
  },
  infoModalLoader: {
    tintColor: COLORS.BLACK,
  },
  infoModalTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: 'uppercase',
    textAlign: "center",
    paddingVertical: 8
  },
  infoModalSubTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center",
    paddingVertical: 8
  },
  infoModalSuccessContainer: {
    width: "100%",
    margin: "auto",
    padding: 0,
    justifyContent: "center",
    alignItems: 'center'
  },
  infoModalSuccessContainerBackgroundImg: {
    width: 70,
    height: 70,
    filter: "invert(1)",
    tintColor: COLORS.PRIMARY_TEXT_COLOR
  },



  // BookingFound Modal
  bookingFoundModalContainer: {
    display: "flex",
    width: "100%",
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    padding: 24,
    flexDirection: "column",
    justifyContent: "center",
    gap: 8
  },
  bookingFoundModalTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: 'uppercase',
    textAlign: "center",
    paddingTop: 8
  },
  bookingFoundModalSubTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center",
    paddingBottom: 8
  },
  bookingFoundModalButtonContainer: {
    flexGrow: 1, 
    justifyContent: "flex-end", 
    alignItems: "center",
    gap: 12
  },


  // Logout Modal

  logoutModalContainer: {
    display: "flex",
    width: "100%",
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    padding: 24,
    flexDirection: "column",
    justifyContent: "center",
    gap: 8
  },
  logoutModalTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: 'uppercase',
    textAlign: "center",
    paddingVertical: 8
  },
  logoutModalButtonContainer: {
    flexGrow: 1, 
    justifyContent: "flex-end", 
    gap: 12
  },



  // Admin Panel Modal

  adminPanelModalContainer: {
    flex: 1,
    maxHeight: 720,
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    padding: 24,
    gap: 16
  },
  adminPanelModalChildContainer: {
    flex: 1,
    gap: 16
  },
  adminPanelModalTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: 'uppercase',
    paddingVertical: 8
  },
  adminPanelModalButtonContainer: {
    flexGrow: 1, 
    justifyContent: "flex-end", 
    gap: 12
  },

  /*
  *
  *
  * LOGIN MODAL
  *
  */
  loginModalContainerOverlay: {
    flex: 1,
    justifyContent: "flex-end",
  },
  loginModalContainer: {
    flex: 1,
    maxHeight: 720,
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    padding: 24,
    gap: 16
  },
  LoginModalTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: 'uppercase',
    paddingVertical: 8
  },
  LoginModalSubTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center",
    paddingBottom: 8
  },
  LoginModalDisclaimerContainer: {
    backgroundColor: COLORS.ACCENT_COLOR,
    paddingVertical: 16,
    paddingHorizontal: 24,
  },
  LoginModalDisclaimerText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.ACCENT_Text_COLOR,
    textAlign: "center"
  },
  LoginModalVersionText: {
    position: "fixed", 
    bottom: 1, 
    left: 0, 
    right: 0,
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center"
  },
  loginModalBottomTxt: {
    display: 'none',
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center"
  },
  loginModalButtonContainer: {
    flexGrow: 1, 
    justifyContent: "flex-end", 
    gap: 12
  },

  // Guest List
  otpPinContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 35,
    marginHorizontal: 16,
  },
  guestListItemContainer: {
    marginBottom: 16
  },
  guestListItemTitle: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textTransform: "capitalize",
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  horizontalline: {
    display: "none"
  },
    /**
   * Parallac Scroll View
   */

  parallaxScrollViewContainer: {
    flex: 1,
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  parallaxScrollViewHeaderContainer: {
    position: 'absolute',
    height: 393,
    zIndex: -1,
    overflow: 'hidden',
    backgroundColor: COLORS.BACKGROUND_COLOR
  },
  parallaxScrollViewChildContainer: {
    // paddingTop: 393,
  },
  parallaxRootContainer: {
    flex: 1,
  },
  parallaxRootContainerHeaderContainer: {
    overflow: 'hidden',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: -1,
  },


  /* Progress Bar */
  progressBarModalContainer: {
    display: "flex",
    width: "100%",
    alignItems: 'center',
    justifyContent: 'center',
    padding: 32,
    gap: 8,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  progressBarContainer_title: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: 'uppercase',
    textAlign: "center",
    paddingVertical: 8
  },
  progressBarContainer: {
    display: 'flex',
    width: "100%",
    paddingVertical: 8,
  },
  progressBar: {
    position: "absolute",
    width: "100%",
    height: 15,
    borderWidth: 2,
    borderRadius: 50,
    borderColor: "rgba(0,0,0,0.2)",
    overflow: "hidden"
  },
  progressBarInnerContainer: {
    width: "100%",
    height: "100%",
    borderWidth: 2,
    borderColor: COLORS.BACKGROUND_COLOR,
  },
  progressBarAnimateContainer: {
    position: "absolute",
    bottom: 0,
    height: "100%",
    borderRadius: 50,
  },
  colorInterpolateProgressBar: {
    inputRange: [0, 100],
    outputRange: [COLORS.SECONDARY_COLOR + "55", COLORS.SECONDARY_COLOR]
  },

  /**
   * Table Reservation
   */
  sevenRoomsMyReservationMainContainerChildContainer: {
    gap: 32, 
    marginTop: 24
  },
  sevenRoomsMyReservationGroupContainerDetailsTextContainer: {
    paddingLeft: 16,
    borderLeftWidth: 5,
    borderLeftColor: COLORS.ACCENT_COLOR,
  },
  sevenRoomsReservationDetailsMainContainerChildContainer: {
    gap: 16, 
    marginTop: 16
  },
  sevenRoomsAvailabilityMainContainerChildContainer: {
    gap: 16, 
    marginTop: 16,
    marginBottom: 100
  },
  sevenRoomsCreatePageMainContainerChildContainer: {
    gap: 16, 
    marginTop: 16
  },
  sevenRoomsReservationDetails_button_container: {
    padding: 16,
    gap: 8,
    position: "absolute",
    bottom: 0,
    width: "100%",
    backgroundColor: COLORS.BACKGROUND_COLOR
  },
  sevenRoomsSuccessMainContainerChildContainer: {
    marginTop: 16
  },
  reservationsSuccessMessage: {
    ...FONT_SMALL,
    ...PRIMARY_FONT,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  sevenRoomsMyReservationWidgetDescription: {
    ...FONT_MEDIUM,
    ...PRIMARY_FONT,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  sevenRoomsDailyProgramAck_question: {
    marginVertical: 16
  },
  sevenRoomsDailyProgramAck_MainContainer: {
    gap: 16
  },
  sevenRoomsEventsHappeningText: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  sevenRoomsDailyProgramAck_itemContainer_childPolicy: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  sevenRoomsDailyProgramAck_itemContainer_spend_policy: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  sevenRoomsDailyProgramAck_itemContainer_table_holding_policy: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  sevenRoomsDailyProgramAck_itemContainer_cuisine: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  sevenRoomsDailyProgramAck_itemContainer_dress_code: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  sevenRoomsDailyProgramAck_itemContainer_price_point: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  sevenRoomsMyReservationGroupContainerDetailsActionCancel: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: "red",
    textTransform: "uppercase"
  },
  sevenRoomsEditButton: {
    height: 20,
    width: 20,
    objectFit: "cover"
  },
  sevenRoomsCancelledButton: {
    tintColor: COLORS.PRIMARY_TEXT_COLOR,
    filter: "invert(1)"
  },
  sevenroomsStartTimeContainer: {
    display: "none"
  },
  sevenroomsEndTimeContainer: {
    display: "none"
  },


  /**
   *
   * INITIAL LOADER SCREEN
   */

  preLoaderContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 10000,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  preLoader_Loader: {

  },
  preLoader_Loaderlottie: {
    flex: 1, 
    width: '100%', 
    height: '100%'
  },
  

  /** WelcomeScreen **/
  welcomeScreenContainer: {
    flex: 1,
    width: "100%",
    alignItems: "center",
    justifyContent: 'flex-end',
    paddingTop: 0,
    paddingBottom: 24,
    gap: 24,
  },
  welcomeScreenImage: {

  },
  welcomeScreenVideo: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: isWeb() ? "100%" : null,
    height: isWeb() ? "100%" : null,
    objectFit: "cover"
  },
  welcomeScrLogoContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    position: "absolute",
    height: "100%",
    width: "100%",
    top: -100,
    zIndex: 2
  },

  welcomeScrTopLogoContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    position: "absolute",
    width: "100%",
    top: 45,
    zIndex: 2
  },
  welcomeScreenTopLogoStyle: {
    width: 107,
    height: 60
  },
  welcomeScreenLogoLottie: {
    flex: 1,
    width: "100%",
    height: "100%",
  },
  welcomeScreenLogoStyle: {
    width: 205,
    height: 143,
  },
  welcomeScreenLogoText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
  },
  welcomeScreenContent: {
    flex: 1,
    maxHeight: 340,
    // backgroundColor: COLORS.PRIMARY_COLOR,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingTop: 40,
    paddingBottom: 48,
    paddingHorizontal: 32,
    // gap: 16,
    justifyContent: 'flex-end'
  },
  welcomeScreenTertiaryBtn: {
    marginBottom: 24,
    alignItems: "center"
  },
  welcomeScreenHeaderTxtCont: {
    display: "none"
  },
  welcomeScreenBottomTxtCont: {
    marginBottom: 24,
  },
  welcomeScreenHeaderTxt: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.WHITE,
    textAlign: "center",
  },
  welcomeScreenBottomTxt: {
    ...SECONDARY_FONT,
    ...FONT_XSMALL,
    textAlign: 'center',
    color: COLORS.WHITE
  },
  welcomeScreenBottomLoginContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 4,
    marginBottom: 24,
  },
  welcomeScreenPrimaryBtn: {
    marginBottom: 8,
    alignItems: "center",
  },
  welcomeScreenBottomLoginTxt: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textAlign: 'center',
    color: COLORS.WHITE
  },
  welcomeScreenBottomLoginBtnTxt: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.WHITE,
    textDecorationLine: "underline"
  },

  welcomeScreenOverlay: {
    display: "none",
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    zIndex: 1,
  },

  // Welcome Screen Landscape
  welcomeScreenContainer_landscape: {
    flex: 1,
    width: "100%",
    justifyContent: 'flex-end',
    paddingTop: 0,
    paddingBottom: 24,
    gap: 24,
  },
  welcomeScreenContainerImage_landscape: { 
    width: "50%", 
    position: "absolute", 
    right: 0, 
    left: null,
    justifySelf: "right" 
  },
  welcomeScreenVideo_landscape: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: isWeb() ? "100%" : null,
    height: isWeb() ? "100%" : null,
    objectFit: "cover"
  },
  welcomeScrLogoContainer_landscape: {
    flex: 1,
    alignItems: 'center',
    height: "100%",
    width: "100%",
    zIndex: 2,
    top: 40,
    maxWidth: "50%",
  },

  welcomeScrTopLogoContainer_landscape: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    position: "absolute",
    width: "100%",
    top: 45,
    zIndex: 2
  },
  welcomeScreenTopLogoStyle_landscape: {
    width: 107,
    height: 60
  },
  welcomeScreenLogoLottie_landscape: {
    flex: 1,
    width: "100%",
    height: "100%",
  },
  welcomeScreenLogoStyle_landscape: {
    width: 255,
    height: 85,
    filter: "invert(1)",
    tintColor: COLORS.BLACK
  },
  welcomeScreenLogoText_landscape: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
  },
  welcomeScreenContent_landscape: {
    // flex: 1,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingVertical: 40,
    paddingHorizontal: 56,
    gap: 16,
    justifyContent: 'flex-end',
    alignItems: "flex-start"
  },
  welcomeScreenTertiaryBtn_landscape: {
    borderColor: COLORS.BLACK,
  },
  welcomeScreenTertiaryBtnTxt_landscape: {
    color: COLORS.BLACK
  },
  welcomeScreenModalContainer_landscape: {
    flex: 1,
    width: "50%",
    justifyContent: 'flex-end',
    gap: 24,
  },
  welcomeScreenModalInnerContainer_landscape: {
    height: "auto",
    justifyContent: "flex-end",
  },
  welcomeScreenHeaderTxtCont_landscape: {
    display: "none",
    zIndex: 3,
  },
  welcomeScreenBottomTxtCont_landscape: {
    marginBottom: 24,
    zIndex: 3,
    width: "100%"
  },
  welcomeScreenHeaderTxt_landscape: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BLACK,
    textAlign: "center",
  },
  welcomeScreenBottomTxt_landscape: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textAlign: 'center',
    color: COLORS.BLACK,
    textTransform: "uppercase",
  },
  welcomeScreenBottomLoginContainer_landscape: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 4,
  },
  welcomeScreenBottomLoginTxt_landscape: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: 'center',
    color: COLORS.BLACK
  },
  welcomeScreenBottomLoginBtnTxt_landscape: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BLACK,
    textDecorationLine: "underline"
  },

  welcomeScreenOverlay_landscape: {
    display: "none",
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    zIndex: 1,
  },
  welcomeScreenPrimaryBtn_landscape: {
     
  },



  /* Widget HomePage Container */
  widgetRootContainer: {
    flex: 1,
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  widgetmainContainer: {
    flexGrow: 1,
  },
  widgetmainContainerHeaderContainer: {
    display: "flex",
    justifyContent: 'center',
    width: "100%"
  },
  widgetmainContainerHeaderImg: {
    width: "100%",
    height: 262,
    maxWidth: 1000,
    margin: "auto",
    objectFit: 'cover',
  },
  widgetmainContainerHeaderTitleContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: 'center',
    gap: 16,
    paddingVertical: 32,
    paddingHorizontal: 16
  },
  widgetmainContainerHeaderTitle: {
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    textTransform: "uppercase",
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  widgetmainContainerHeaderSubTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: "center",
    paddingHorizontal: 24,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  widgetmainContainerHeaderSubTitle2: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: "center",
    paddingHorizontal: 24,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  widgetmainContainerChildContainer: {
    flex: 1,
    paddingHorizontal: 16
  },

  /* Softphone */


  widgetModalContainer: {
    flex: 1,
    justifyContent: "center",
  },

  widgetModalRootContainer: {
    flex: 1,
    backgroundColor: COLORS.BACKGROUND_COLOR,
    height: "100%",
    width: "100%",
    maxWidth: 450,
    alignSelf: "flex-end",
  },
  widgetModalMainContainer: {
    flexGrow: 1,
  },
  widgetModalMainContainerChildContainer: {
    flex: 1,
  },
  softphoneMainContainerChildContainer: {
    flexGrow: 1,
    justifyContent: "space-between",
    paddingHorizontal: 24,
    paddingVertical: 24,
    paddingBottom: 60,
    gap: 20
  },


  softphoneRegistrationAdvanceSettingContainer: {
    flex: 1,
    gap: 20
  },
  softphoneRegistrationAdvancedSettingsToggle: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },


  softphoneRegistrationNoticeText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },



  softphoneDisplayNameText: {
    ...SECONDARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center",
    paddingTop: 16
  },

  softphoneInCallButtonContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 20,
  },
  softphoneCallButtonContainer: {
    flexDirection: "row",
    height: 50,
    justifyContent: "space-around",
    alignItems: "center",
    gap: 20
  },
  softphoneRootCrossContainer: {
    width: 24,
    height: 24,
    position: "absolute",
    top: 50,
    left: 25,
    zIndex: 1000
  },
  softphoneRootCrossImageContainer: {
    tintColor: COLORS.BACKGROUND_COLOR_CONTRAST,
    filter: "invert(1)"
  },

  softphoneAnswerButton: {
    width: 60, 
    height: 60, 
    borderRadius: 50, 
    justifyContent: "center", 
    alignItems: "center", 
    backgroundColor: COLORS.SUCCESS,
  },
  softphoneAnswerButtonIcon: {
    width: 24,
    height: 24,
    tintColor: COLORS.WHITE
  },

  softphoneEndButton: {
    width: 60, 
    height: 60, 
    borderRadius: 50, 
    justifyContent: "center", 
    alignItems: "center", 
    backgroundColor: COLORS.ERROR,
  },
  softphoneEndButtonIcon: {
    width: 24,
    height: 24,
    tintColor: COLORS.WHITE
  },

  softphoneExtraButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 60,
    height: 60,
    gap: 30,
    borderRadius: 50,
    borderWidth: 1,
    borderColor: COLORS.BLACK,
    backgroundColor: COLORS.BACKGROUND_COLOR_SECONDARY
  },
  softphoneExtraButtonIcon: {
    width: 24,
    height: 24,
    tintColor: COLORS.BACKGROUND_COLOR_CONTRAST,
  },

  softphoneExtraButtonActive: {
    backgroundColor: COLORS.ACCENT_COLOR,
  },
  softphoneExtraButtonIconActive: {
    tintColor: COLORS.ACCENT_Text_COLOR,
    filter: "invert(1)"
  },


  softphoneContentContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    gap: 20,
    paddingBottom: 24
  },


  softphoneRecentContainer: {
    padding: 20,
  },
  softphoneRecentEmptyText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center",
  },

  softphoneInputBox: {
    width: "100%", 
    paddingHorizontal: 20,
  },
  softphoneInput: {
    border: "none",
    ...FONT_LARGE
  },
  softphoneQuickActionsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    gap: 20,
  },
  softphoneQuickAction: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 60,
    height: 60,
    gap: 30,
    borderRadius: 5,
    borderWidth: 1,
    borderColor: COLORS.BLACK,
    backgroundColor: COLORS.BACKGROUND_COLOR_SECONDARY
  },
  softphoneQuickActionText: {
    ...SECONDARY_FONT,
    ...FONT_XSMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: "center",
  },
  softphoneKeypadContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 20,
  },
  softphoneKeypadRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    gap: 20,
  },
  softphoneKeyButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 60,
    height: 60,
    gap: 30,
    borderRadius: 50,
    borderWidth: 1,
    borderColor: COLORS.BLACK,
    backgroundColor: COLORS.BACKGROUND_COLOR_SECONDARY
  },
  softphoneKeyButtonText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: "center",
  },

  softphoneCallButton: {
    width: 60, 
    height: 60, 
    borderRadius: 50, 
    justifyContent: "center", 
    alignItems: "center", 
    backgroundColor: COLORS.ACCENT_COLOR,
  },
  softPhoneCallButtonIcon: {
    width: 24,
    height: 24,
  },
  softphoneBackButton: {
    width: 60, 
    height: 60, 
    borderRadius: 50, 
    justifyContent: "center", 
    alignItems: "center", 
    position: "absolute",
    left: 85,
  },
  softPhoneBackButtonIcon: {
    width: 20,
    height: 20,
  },

  /* List Component */

  list_itemContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 16,
    gap: 16,
    width: "100%",
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.10)"
  },
  list_itemContainer_image: {
    width: 72,
    height: 72,
  },
  list_itemContainer_textContainer: {
    flex: 1,
    height: 72,
    justifyContent: 'center'
  },
  list_itemContainer_textContainer_title: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
    fontSize: 16,
    lineHeight: 24
  },
  list_itemContainer_textContainer_subtitle: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
  },
  list_itemContainer_textContainer_tertiaryContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 8
  },
  list_itemContainer_arrow: {
    padding: 16,
    width: 45,
    height: 45
  },
  list_itemContainer_arrow_img: {
    height: "100%",
    width: "100%",
    objectFit: "contain"
  },



  /* Widget Skeleton */

  widgetSkeletonRootContainer: {
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 1000,
    backgroundColor: COLORS.WHITE
  },
  widgetSkeletonMainContainer: {

  },
  widgetSkeletonHeaderContainer: {

  },
  widgetSkeletonHeaderImg: {
    maxWidth: null
  },
  widgetSkeletonMainContainerChildContainer: {

  },
  widgetSkeleton_itemContainer: {

  },
  widgetSkeleton_itemContainer_image: {

  },
  widgetSkeleton_itemContainer_textContainer: {
    gap: 8
  },
  widgetSkeleton_itemContainer_textContainer_title: {
    width: "100%"
  },
  widgetSkeleton_itemContainer_textContainer_subtitle: {

  },

  /**
 *
 * HOTEL LIST WIDGET
 *
 */
  hotelListWidgetRootContainer: {
    paddingBottom: 148
  },
  hotelListWidgetMainContainer: {

  },
  hotelListWidgetHeaderContainer: {

  },
  hotelListWidgetHeaderImg: {
    objectFit: 'cover'
  },
  hotelListWidgetHeaderTitleContainer: {

  },
  hotelListWidgetHeaderTitle: {

  },
  hotelListWidgetHeaderSubTitle: {

  },
  hotelListWidgetMainContainerChildContainer: {

  },
  hotelListWidgetChildContainer: {
    gap: 16,
    paddingVertical: 16
  },
  hotelListWidgetChildContainerTitle: {
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  hotelListWidgetChildContainer_items_container: {

  },

  hotelListWidgetChildContainer_itemContainer: {

  },
  hotelListWidgetChildContainer_itemContainer_highlight:{
    backgroundColor: COLORS.LIGHT_GREY,
  },
  hotelListWidgetChildContainer_itemContainer_master: {
    display: "none"
  },
  hotelListWidgetChildContainer_itemContainer_image: {

  },
  hotelListWidgetChildContainer_itemContainer_textContainer: {

  },
  hotelListWidgetChildContainer_itemContainer_textContainer_title: {

  },
  hotelListWidgetChildContainer_itemContainer_textContainer_subtitle: {

  },
  hotelListWidgetChildContainer_itemContainer_arrow: {

  },

  hotelListErrorContainer: {
    width: "90%",
    display: "flex",
    justifyContent: "center",
    alignSelf: "flex-start",
    alignItems: "center",
    borderWidth: 1,
    padding: 32,
    marginBottom: 32,
    marginHorizontal: "auto",
    backgroundColor: COLORS.PRIMARY_COLOR
  },
  hotelListErrorContainerText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: 'center',
    color: COLORS.PRIMARY_TEXT_COLOR
  },

  /* 
    Selfie Tip Overlay
  */

  selfieTipOverlay: {
    position: "absolute",
    justifyContent: "center",
    width: "100%"
  },
  selfieTipIcon: {
    height: 20,
    width: 25
  },
  selfieTipText: {
    color: COLORS.SECONDARY_TEXT_COLOR,
  },

  selfieTipTextContainer:{
    position: "absolute",
    top: height * 0.22,
    left: "50%",
    bottom: 0,
    transform: [{ translateX: -100 }],
  },
  infoIcon: {
    height: 25,
    width: 25
  },
  instructionText: {
    color: COLORS.SECONDARY_TEXT_COLOR,
  },
  instructionContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    paddingTop: 20,
    paddingHorizontal: 40,
    gap: 5
  },

  selfieTipOverlayArrows: {
    borderWidth: 0,
    position: "relative",
    alignSelf: 'center',
    overflow: 'hidden',
    maxWidth: "80%"
  },


  selfieTipOverlayBG: {
    position: "absolute", 
    top: 0, 
    left: 0, 
    right: 0, 
    bottom: 0, 
    width: width, 
    height: height, 
    opacity: 0.5,
    maxWidth: GENERAL_MAX_WIDTH
  },

  selfieTipOverlayImage: {
    position: "absolute", 
    top: 0, 
    left: 0, 
    right: 0, 
    bottom: 0, 
    width: width, 
    height: height,
    maxWidth: GENERAL_MAX_WIDTH
  },

  /* Picture Preview */

  picturePreviewRootContainer: {

  },
  picturePreviewMainContainer: {

  },
  picturePreviewHeaderContainer: {
    height: "65%",
    width: "100%",
  },
  picturePreviewHeaderImg: {
    minHeight: 343,
    height: "100%",
    width: "100%",
    objectFit: "contain",
    resizeMode: "contain"
  },
  picturePreviewMainContainerChildContainer: {

  },
  picturePreviewMainContainerChildContainer_textContainer: {
    display: "flex",
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    paddingVertical: 16
  },
  picturePreviewMainContainerChildContainer_textContainer_title: {
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  picturePreviewMainContainerChildContainer_textContainer_subtitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  picturePreviewMainContainerChildContainer_buttonContainer: {
    gap: 8,
    paddingVertical: 16
  },


  cameraRootContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.BACKGROUND_COLOR
  },
  cameraRootContainer_loader: {

  },
  captureButton: {
    zIndex: 100,
    position: 'absolute',
    bottom: 40,
    alignSelf: 'center',
    backgroundColor: COLORS.WHITE,
    width: 80,
    height: 80,
    borderRadius: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  captureButton_innerCircle: {
    borderWidth: 1,
    borderColor: COLORS.BLACK,
    width: 70,
    height: 70,
    borderRadius: 35,
  },

  id_instructionContainer: {
    flexDirection: 'row',
    position: 'absolute',
    bottom: 130,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 8,
    gap: 12
  },
  id_instructionInfoImage: {
    width: 24,
    height: 24,
    flexShrink: 0,
  },
  id_instructionText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: 'left',
    color: COLORS.WHITE
  },

  id_instructionOverlayContainer: {
    top: -70
  },
  id_instructionOverlayTop: {
    flex: 1, 
    backgroundColor: 'rgba(0,0,0,0.6)'
  },
  id_instructionOverlayMiddle: {
    flexDirection: 'row', 
    height: "65%"
  },
  id_instructionOverlayBottom: {
    flex: 1, 
    backgroundColor: 'rgba(0,0,0,0.6)'
  },

  id_instructionOverlayMiddleLeft: {
    flex: 1, 
    backgroundColor: 'rgba(0,0,0,0.6)'
  },
  id_instructionOverlayMiddleMiddle: {
    width: "80%", 
    backgroundColor: 'transparent'
  },
  id_instructionOverlayMiddleRight:{
    flex: 1, 
    backgroundColor: 'rgba(0,0,0,0.6)'
  },



  /**
 *
 * CheckInGuide
 */
  checkInGuideRootContainer: {

  },
  checkInGuideMainContainer: {
    // if you want to add maxWidth add that in this container
  },
  checkInGuideMainContainerHeaderContainer: {
    justifyContent: "space-between"
  },
  checkInGuideMainContainerHeaderImg: {
    height: 393,
    margin: null
  },
  checkInGuideMainContainerHeaderTitleContainer: {

  },
  checkInGuideMainContainerHeaderTitle: {

  },
  checkInGuideMainContainerHeaderSubTitle: {

  },
  checkInGuideMainContainerChildContainer: {

  },
  checkInGuideButtonContainer: {
    paddingVertical: 16,
    gap: 16
  },

  doorkeyGuideRootContainer: {

  },
  doorkeyGuideMainContainer: {

  },
  doorkeyGuideMainContainerHeaderImg: {
    height: 393,
    margin: null
  },
  doorkeyGuideMainContainerHeaderTitleContainer: {

  },
  doorkeyGuideMainContainerHeaderTitle: {
    width: '100%'
  },
  doorkeyGuideMainContainerHeaderSubTitle: {

  },
  doorkeyGuideMainContainerHeaderContainer: {

  },
  doorkeyGuideMainContainerChildContainer: {
    marginBottom: 30
  },
  dookeyGuideButtonContainer: {
    paddingBottom: 16,
    gap: 16
  },
  //  Doorkey index.js
  doorkeyRootContainer: {

  },
  doorkeyMainContainer: {

  },
  doorkeyMainContainerHeaderTitleContainer: {

  },
  doorkeyMainContainerHeaderTitle: {

  },
  doorkeyMainContainerHeaderSubTitle: {

  },
  doorkeyMainContainerHeaderContainer: {

  },
  doorkeyMainContainerChildContainer: {
    alignItems: "center"
  },

  // OTP screen
  otpRootContainer: {

  },
  otpMainContainer: {

  },
  otpMainContainerHeaderTitleContainer: {

  },
  otpMainContainerHeaderTitle: {

  },
  otpMainContainerHeaderSubTitle: {

  },
  otpMainContainerHeaderContainer: {

  },

  /**
   * Offline Modal Container
   */
  offlineModalContainer:{
    flex: 1, 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  offlineModalTitle: {
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  offlineModalSubtitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },

  /**
 *
 * Booking Info
 */
  bookingInfoRootContainer: {

  },
  bookingInfoMainContainer: {

  },
  bookingInfoHeaderContainer: {

  },
  bookingInfoHeaderImg: {

  },
  bookingInfoHeaderTitleContainer: {

  },
  bookingInfoHeaderTitle: {

  },
  bookingInfoHeaderSubTitle: {

  },
  bookingInfoMainContainerChildContainer: {
    flex: 1,
    padding: 16,
    gap: 24
  },

  bookingInfoMainContainerChildContainer_infotext: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: "center"
  },

  /* ID Verification */
  verifyIdentityRootContainer: {

  },
  verifyIdentityMainContainer: {

  },
  verifyIdentityHeaderContainer: {

  },
  verifyIdentityHeaderTitleContainer: {

  },
  verifyIdentityHeaderTitle: {

  },
  verifyIdentityHeaderSubTitle: {

  },
  verifyIdentityMainContainerChildContainer: {
    gap: 24
  },
  verifyIdentityChildContainer_imageButtonContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    alignItems: "flex-start",
    width: "100%",
    marginHorizontal: "auto",
  },
  verifyIdentityChildContainer_imageButtonContainer_button: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    paddingVertical: 12,
    paddingHorizontal: 20,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 16,
    gap: 16,
    backgroundColor: COLORS.WHITE
  },
  verifyIdentityChildContainer_imageButtonContainer_buttonSelected: {
    backgroundColor: COLORS.SECONDARY_COLOR,
  },
  verifyIdentityChildContainer_imageButtonContainer_button_iconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: 'center',
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: "gray",
  },
  verifyIdentityChildContainer_imageButtonContainer_button_iconContainerSelected: {
    backgroundColor: COLORS.PRIMARY_COLOR
  },
  verifyIdentityChildContainer_imageButtonContainer_button_icon: {
    width: 20,
    height: 20,
    flexShrink: 0,
    tintColor: COLORS.BLACK,
    filter: "invert(1)"
  },
  verifyIdentityChildContainer_imageButtonContainer_button_iconSelected: {
    tintColor: COLORS.PRIMARY_TEXT_COLOR,
    filter: "invert(1)"
  },
  verifyIdentityChildContainer_imageButtonContainer_button_textContainer: {
    flex: 1,
    gap: 4
  },
  verifyIdentityChildContainer_imageButtonContainer_button_textContainer_title: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BLACK
  },
  verifyIdentityChildContainer_imageButtonContainer_button_textContainer_titleSelected: {
    color: COLORS.SECONDARY_TEXT_COLOR
  },
  verifyIdentityChildContainer_imageButtonContainer_button_textContainer_subtitle: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BLACK
  },
  verifyIdentityChildContainer_imageButtonContainer_button_textContainer_subtitleSelected: {
    color: COLORS.SECONDARY_TEXT_COLOR
  },
  verifyIdentityChildContainer_imageButtonContainer_button_chevron: {
    tintColor: COLORS.BLACK,
  },
  verifyIdentityChildContainer_imageButtonContainer_button_chevronSelected: {
    tintColor: COLORS.SECONDARY_TEXT_COLOR,
    filter: "invert(1)"
  },
  verifyIdentityChildContainer_infoText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: "center"
  },
  verifyIdentityChildContainer_buttonContainer: {
    paddingVertical: 16,
    gap: 8
  },

  idVerificationSuccessContainerHeaderImgContainer: {
    width: "100%",
    maxWidth: 1000,
    margin: "auto",
    padding: 28,
    paddingTop: 40,
    justifyContent: "center",
    alignItems: 'center',
    height: 392
  },
  idVerificationSuccessContainerHeaderImg: {
    height: 154,
    width: 154,
    tintColor: COLORS.SECONDARY_TEXT_COLOR,

    filter: "brightness(0) saturate(100%)",
  },

  idVerificationSuccessCheckIconContainer: {
    flexDirection: "row",
    gap: 24
  },
  idVerificationSuccessCheckIcon: {
    height: 24,
    width: 24
  },
  idVerificationSuccesspreCheckInHeaderTitleContainer: {
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  idVerificationSuccessCheckIcon1: {
    height: 24,
    width: 24,

    backgroundColor: COLORS.SECONDARY_COLOR,
    borderRadius: "50%",
  },
  idVerificationSuccessMainContainerChildContainer_textContainer: {
    alignItems: "center"
  },
  idVerificationSuccessMainContainerChildContainer_infotext: {
    textAlign: "center"
  },
  idVerificationSuccessMainContainerChildContainer_subinfotext: {
    textAlign: "center"
  },
  idVerificationSuccessMainContainerChildContainer_buttonContainer: {
    padding: 16,
    gap: 8
  },


  /** Disclaimer */
  checkInDisclaimerHeaderContainer: {
    display: "none"
  },
  checkInDisclaimerMainContainerChildContainer: {
    paddingTop: 40,
  },
  checkInDisclaimerRootContainer: {
    position: "absolute",
    height: "100%",
    width: "100%",
  },
  checkInDisclaimerHeaderTitleContainer: {

  },
  checkInDisclaimer_HeaderTitle: {

  },
  checkInDisclaimer_webview: {
    borderColor: "rgba(0, 0, 0, 0.10)",
    borderWidth: 0.5,
    borderRadius: 8,
    // flex: 1,
    // backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  checkInDisclaimer_textContainer: {

  },
  checkInDisclaimer_checkbox: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 16,
    marginTop: 20,
  },
  checkInDisclaimer_signature: {
    marginVertical: 16,
    borderColor: "rgba(0, 0, 0, 0.10)",
    borderWidth: 0.5,
    borderRadius: 8,
    backgroundColor: COLORS.BACKGROUND_COLOR,
    height: 200,
    width: "100%",
  },
  checkInDisclaimer_signature_canvas: {
    backgroundColor: COLORS.BACKGROUND_COLOR,
    height: 200,
  },
  disclaimerFooterContainer: {
    width: '100%',
    padding: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR,
    gap: 10,
  },
  checkInDisclaimer_checkbox_text: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: "left",
    marginRight: 24, 
    marginLeft: 16, 
    marginTop: -5
  },


  /* Card Validation */
  cardValidationRootContainer: {

  },
  cardValidationMainContainer: {

  },
  cardValidationHeaderContainer: {

  },
  cardValidationHeaderTitleContainer: {

  },
  cardValidationHeaderTitle: {

  },
  cardValidationHeaderSubTitle: {

  },
  cardValidationMainContainerChildContainer: {
    paddingVertical: 16,
    gap: 24
  },
  cardValidationChildContainer_buttonContainer: {
    paddingVertical: 16,
    gap: 8
  },


  elavonCardModalStyle: {
    flex: 1
  },
  elavonCardContainer: {
    // display: "flex",
    // height: "70%",
    flex: 1, // important to apply margin top
    borderWidth: 0.5,
    borderRadius: 16,
    overflow: "hidden",
    borderColor: COLORS.BACKGROUND_COLOR,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },
  elavonCardContainer_iframe: {
    height: "100vh",
    borderWidth: 0.5,
    borderRadius: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },
  elavonCardContainer_webview: {
    flex: 1,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },

  shift4CardContainer: {
    flex: 1,
    overflow: "hidden",
    borderColor: COLORS.BACKGROUND_COLOR,
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  
  shift4CardContainer_iframe: {
    flex: 1,
    borderWidth: 0,
    borderRadius: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },
  shift4CardContainer_webview: {
    flex: 1,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },

  pciProxyCardContainer: {
    // display: "flex",
    // height: "70%",
    flex: 1, // important to apply margin top
    // borderWidth: 0.5,
    // borderRadius: 16,
    minHeight: 180,
    overflow: "hidden",
    borderColor: COLORS.BACKGROUND_COLOR,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },
  pciProxyCardContainer_iframe: {
    flex: 1,
    borderWidth: 0,
    borderRadius: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },
  pciProxyCardContainer_webview: {
    flex: 1,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },




  additionalDetailsRootContainer: {

  },
  additionalDetailsMainContainer: {

  },
  additionalDetailsHeaderContainer: {

  },
  additionalDetailsHeaderTitleContainer: {

  },
  additionalDetailsHeaderTitle: {

  },
  additionalDetailsHeaderSubTitle: {

  },
  additionalDetailsMainContainerChildContainer: {

  },

  dynamicFormMainContainer: {
    flex: 1
  },
  dynamicFormChildContainer: {
    flex: 1,
    gap: 24
  },
  dynamicFormChildContainer_nestedObjContainer: {
    gap: 4
  },
  dynamicFormChildContainer_nestedObjContainer_heading: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textTransform: "capitalize",
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  dynamicFormChildContainer_nestedObjContainer_description: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textTransform: "capitalize",
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  dynamicFormChildContainer_nestedObjInnerContainer: {
    marginTop: 24,
    gap: 16
  },
  dynamicFormCheckboxContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
    paddingVertical: 16
  },
  dynamicFormCheckBox: {
    borderRadius: 10,
  },
  dynamicFormCheckBoxText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  noticeText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  addressCointainer: {
    flex: 1,
    gap: 16
  },
  addressChildCointainer: {
    flex: 1,
    gap: 8
  },

  dynamicFormButtonContainer: {
    paddingVertical: 16,
    gap: 16
  },




  preCheckInRootContainer: {

  },
  preCheckInMainContainer: {

  },
  preCheckInHeaderContainer: {
    // maxHeight: 393
  },
  preCheckInContainerHeaderImgContainer: {
    width: "100%",
    padding: 0,
    justifyContent: "center",
    alignItems: 'center',
    height: 392
  },
  preCheckInContainerHeaderImgBackground: {

  },
  preCheckInContainerHeaderImg: {
    width: 55,
    height: 55,
    tintColor: COLORS.ACCENT_COLOR
  },
  preCheckInHeaderTitleContainer: {
    paddingVertical: 16,
    paddingHorizontal: 0,
  },
  preCheckInHeaderTitle: {

  },
  preCheckInHeaderSubTitle: {

  },
  preCheckInMainContainerChildContainer: {
    marginBottom: 160,
    justifyContent: "center",
  },
  preCheckInMainContainerChildContainer_infoText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: "center"
  },

  preCheckInMainContainerChildContainer_TextContainer: {
    gap: 8,
    marginBottom: 24,
    width: "100%"
  },
  preCheckInSuccessFooterContainer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    gap: 16,
    padding: 16,
    alignItems: "flex-start",
    backgroundColor: COLORS.PRIMARY_COLOR
  },

  /** Accompany Guest Input */
  accompanyGuestDetailsMainContainer: {
    paddingBottom: 88
  },
  accompanyGuestTextContainer: {
    ...FONT_MEDIUM,
    ...PRIMARY_FONT,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  accompanyGuestInputGuestHeading: {
    ...FONT_MEDIUM,
    ...PRIMARY_FONT,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
  },
  accompanyGuestCheckboxText: {
    ...FONT_MEDIUM,
    ...PRIMARY_FONT,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
  },
  accompanyGuestCheckBox: {
    borderRadius: 10,
  },
  accompanyGuestInputGuestChildContainer: {
    // gap: 16,
    paddingTop: 16,
    paddingBottom: 40,
  },
  accompanyGuestLastNameContainer: {
    paddingTop: 16,
  },
  accompanyGuestCheckboxContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
    paddingVertical: 16
  },

  accompanyGuestChildCheckboxContainer: {
    flexDirection: "row",
    gap: 16,
    justifyContent: "center",
    alignItems: "center",
  },

  accompanyGuestCheckboxInputContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    height: 56,
  },
  accompanyGuestCheckboxInputText: {
    width: 115,
    // height: 52,
  },

  /** Accompany Guest List */
  accompanyGuestDetailsReviewItemText: {
      ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
    fontSize: 16,
    lineHeight: 24
  },


  accompanyGuestDetailsTitleContainer: {
    paddingBottom: 20,  
  },
  accompanyGuestDetailsTitle: {
    textAlign: 'center',
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  accompanyGuestUpdateContainer: {
    bottom: 0,
    width: '100%',
    position: 'absolute',
    padding: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR,
    gap: 10,
  },


  checkInSuccessRootContainer: {

  },
  checkInSuccessMainContainer: {

  },
  checkInSuccessHeaderContainer: {

  },
  checkInSuccessContainerHeaderImgContainer: {
    width: "100%",
    padding: 0,
    justifyContent: "center",
    alignItems: 'center',
    height: 392
  },
  checkInSuccessContainerHeaderImgBackground: {

  },
  checkInSuccessContainerHeaderImg: {
    width: 55,
    height: 55,
    tintColor: COLORS.ACCENT_COLOR
  },
  checkInSuccessHeaderTitleContainer: {
    paddingTop: 16,
    paddingBottom: 12,
    paddingHorizontal: 0,
  },
  checkInSuccessHeaderTitle: {

  },
  checkInSuccessHeaderSubTitle: {

  },
  checkInSuccessMainContainerChildContainer: {
    paddingTop: 16,
    marginBottom: 160,
  },
  checkInSuccessMainContainerChildContainer_textContainer: {
    gap: 16,
  },
  checkInSuccessMainContainerChildContainer_infotext: {
    ...FONT_XLARGE,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: 'center',
    textTransform: "uppercase",
  },
  checkInSuccessMainContainerChildContainer_infotext_roomnumber: {
    ...FONT_XLARGE,
  },
  checkInSuccessMainContainerChildContainer_subinfotext: {
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: "center"
  },
  checkInSuccessFooterContainer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    gap: 16,
    padding: 16,
    alignItems: "flex-start",
    backgroundColor: COLORS.PRIMARY_COLOR
  },



  /* InnSpire ChatBot */

  innspireChatContainer: {
    flex: 1,
    height: "100%",
    width: "100%",
    overflow: "hidden",
    justifyContent: 'center',
    objectFit: "cover",
    maxWidth: GENERAL_MAX_WIDTH,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },
  innspireChatContainer_iframe: {
    flex: 1,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },
  innspireChatContainer_webview: {
    flex: 1,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },


  /** Dining Reservations */
  reservations_itemContainer_textContainer: {
    height: "auto",
  },
  reservations_itemContainer_textContainer_subtitle: {

  },
  reservationsNoReservationErrorContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 24,
    marginTop: 16,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.10)",
  },
  reservationsNoReservationError: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  reservationsNextButtonContainer: {
    bottom: 0,
    width: '100%',
    // position: 'absolute',
    padding: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR,
    gap: 10,
  },


  checkboxContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
    paddingVertical: 16
  },
  checkBox: {
    borderRadius: 10,
  },
  checkBoxText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  reservationsInputContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  reservationsMainContainerSuccessText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: "center"
  },

  labelValueMainContainer: {
    display: "flex",
    justifyContent: "space-between",
    paddingVertical: 8,
  },
  labelValueContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 8,
  },
  labelValueContainer_label: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  labelValueContainer_value: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  /**
 *
 * NOTIFICATION
 *
 */

  notificationsRootContainer: {

  },
  notificationsMainContainer: {

  },
  notificationsMainContainerChildContainer: {

  },
  noMessageContainer: {
    justifyContent: "center",
    alignItems: "center",
    gap: 16,
    paddingVertical: 16
  },
  noMessageContainer_img: {
    width: 80,
    height: 80
  },
  noMessageContainer_text: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textAlign: "center",
    textTransform: "capitalize",
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  notification_itemContainer: {

  },
  notificationdot_container: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    paddingRight: 8,
  },
  notificationDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: COLORS.SECONDARY_COLOR,
  },
  notificationDot_placeholder: {
    width: 8,
    height: 8,
    borderRadius: 4,
  },
  notification_itemContainer_textContainer: {

  },
  notification_itemContainer_textContainer_title: {

  },
  notification_itemContainer_textContainer_subtitle: {

  },
  notification_itemContainer_arrow: {

  },

  /**
   *
   * NOTIFICATION DETAIL
   *
   */
  notificationDetailRootContainer: {

  },
  notificationDetailHeaderContainer: {

  },
  notificationDetailHeaderTitleContainer: {

  },
  notificationDetailHeaderTitle: {

  },
  notificationDetailMainContainer: {

  },
  notificationDetailMainContainerChildContainer: {
    gap: 24
  },
  notificationDetailContainer: {
    gap: 24
  },
  notificationDetailContainer_datetext: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  notificationDetailContainer_primarytext: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  notificationDetailContainer_secondarytext: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },



  /**
 *
 * HCommerce
 *
 */

  hcommerceRootContainer: {

  },
  hcommerceMainContainer: {

  },
  hcommerceHeaderContainer: {

  },
  hcommerceHeaderImg: {

  },
  hcommerceHeaderTitleContainer: {

  },
  hcommerceHeaderTitle: {

  },
  hcommerceHeaderSubTitle: {

  },
  hcommerceMainContainerChildContainer: {

  },

  hcommerce_itemContainer: {

  },
  hcommerce_itemContainer_image: {

  },
  hcommerce_itemContainer_textContainer: {

  },
  hcommerce_itemContainer_textContainer_title: {

  },
  hcommerce_itemContainer_arrow: {

  },


  hcommerce_storelevel1_item_image: {
    objectFit: "cover",
    borderRadius: 10,
    width: '100%',
    height: '100%',
  },
  hcommerce_storelevel1_MainContainer: {
    flex: 1
  },
  hcommerce_storelevel1_HeaderContainer: {

  },
  hcommerce_storelevel1_HeaderImg: {
    display: "none"
  },
  hcommerce_storelevel1_HeaderTitleContainer: {

  },
  hcommerce_storelevel1_HeaderTitle: {

  },
  hcommerce_storelevel1_MainContainerChildContainer: {
    flex: undefined,
    paddingBottom: 148
  },
  hcommerce_orderdetails_HeaderOrderDetailsContentContainer: {

  },

  hcommerce_storelevel1_PillContainer: {
    display: "flex",
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    marginBottom: 0
  },
  hcommerce_storelevel1_Pill: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderBottomWidth: 0.5,
    borderColor: "rgba(0, 0, 0, 0.10)"
  },
  hcommerce_storelevel1_Pill_Text: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  hcommerce_storelevel1_SelectedPill: {
    borderBottomWidth: 2,
    borderColor: COLORS.ACCENT_COLOR
  },
  hcommerce_storelevel1_SelectedPill_Text: {
    color: COLORS.ACCENT_COLOR
  },

  hcommerce_storelevel1_ChildContainer: {
    gap: 16,
    paddingVertical: 16
  },
  hcommerce_storelevel1_ChildContainer_Title: {
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  hcommerce_storelevel1_ChildContainer_items_container: {

  },

  hcommerce_storelevel1_itemContainer: {

  },
  hcommerce_storelevel1_itemContainer_image: {

  },
  hcommerce_storelevel1_itemContainer_textContainer: {

  },
  hcommerce_storelevel1_itemContainer_textContainer_title: {

  },
  hcommerce_storelevel1_itemContainer_textContainer_currencytitle: {

  },
  hcommerce_storelevel1_itemContainer_textContainer_subtitle: {

  },
  hcommerce_storelevel1_itemContainer_arrow: {

  },

  /** Store Level 1 Landscape */

  hcommerce_storelevel1_landscape_item_image: {
    height: "100%",
    width: "100%",
    objectFit: "cover",
  },
  hcommerce_storelevel1_landscape_MainContainer: {
    flex: 1
  },
  hcommerce_storelevel1_landscape_HeaderContainer: {

  },
  hcommerce_storelevel1_landscape_HeaderImg: {
    display: "none"
  },
  hcommerce_storelevel1_landscape_HeaderTitleContainer: {
    justifyContent: "flex-start",
    alignItems: "flex-start",
    paddingVertical: 0,
  },
  hcommerce_storelevel1_landscape_HeaderTitle: {
    textTransform: null,
  },
  hcommerce_storelevel1_landscape_MainContainerChildContainer: {
    flex: undefined,
    paddingBottom: 148
  },
  hcommerce_storelevel1_landscape_MainContainerChildContainerPillContainer: {
    padding: 30,
    paddingHorizontal: 30
  },

  hcommerce_storelevel1_landscape_PillContainer: {
    display: "flex",
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.10)",
    padding: 5,
    gap: 8,
    backgroundColor: COLORS.BACKGROUND_COLOR_SECONDARY,
  },
  hcommerce_storelevel1_landscape_Pill: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 16,
    paddingVertical: 8,

  },
  hcommerce_storelevel1_landscape_Pill_Text: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  hcommerce_storelevel1_landscape_SelectedPill: {
    borderRadius: 5,
    backgroundColor: COLORS.SECONDARY_COLOR
  },
  hcommerce_storelevel1_landscape_SelectedPill_Text: {
    color: COLORS.SECONDARY_TEXT_COLOR
  },

  hcommerce_storelevel1_landscape_ChildContainer: {
    gap: 16,
    paddingVertical: 16
  },
  hcommerce_storelevel1_landscape_ChildContainer_Title: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  hcommerce_storelevel1_landscape_ChildContainer_items_container: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 16
  },

  hcommerce_storelevel1_landscape_itemContainer: {
    height: 280,
    width: 220,
    padding: 16,
    gap: 12,
    flexDirection: "column",
    
    alignItems: "flex-start",
    
    borderRadius: 5,
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.2)",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.2,
    shadowRadius: 4,
  },
  hcommerce_storelevel1_landscape_itemContainer_image: {
    height: 140,
    width: 188,
    borderRadius: 5
  },
  hcommerce_storelevel1_landscape_itemContainer_textContainer: {
    width: "100%"
  },
  hcommerce_storelevel1_landscape_itemContainer_textContainer_title: {
    textTransform: null,
  },
  hcommerce_storelevel1_landscape_itemContainer_textContainer_currencytitle: {

  },
  hcommerce_storelevel1_landscape_itemContainer_textContainer_subtitle: {
    textTransform: null,
  },
  hcommerce_storelevel1_landscape_itemContainer_arrow: {

  },


  hcommerce_storelevel2_item_image: {
    objectFit: "cover",
    borderRadius: 10,
    width: '100%',
    height: '100%',
  },

  hcommerce_storelevel2_MainContainer: {
    flex: 1
  },

  hcommerce_storelevel2_HeaderContainer: {

  },
  hcommerce_storelevel2_HeaderImg: {
    display: "none"
  },
  hcommerce_storelevel2_HeaderTitleContainer: {

  },
  hcommerce_storelevel2_HeaderTitle: {

  },
  hcommerce_storelevel2_HeaderSubTitle: {

  },

  hcommerce_menuUnavailableBanner: {
    marginHorizontal: 16,
    marginTop: 8,
    marginBottom: 4,
    paddingVertical: 10,
    paddingHorizontal: 14,
    backgroundColor: 'rgba(255, 87, 51, 0.1)',
    borderLeftWidth: 3,
    borderLeftColor: '#FF5733',
    borderRadius: 6,
  },
  hcommerce_menuUnavailableBannerText: {
    fontSize: 13,
    color: '#CC3300',
  },
  hcommerce_storelevel2_MainContainerChildContainer: {
    flex: undefined,
    paddingBottom: 148
  },
  hcommerce_storelevel2_ChildContainer_items_container: {

  },
  hcommerce_storelevel2_itemContainer: {

  },
  hcommerce_storelevel2_itemContainer_image: {

  },
  hcommerce_storelevel2_itemContainer_textContainer: {

  },
  hcommerce_storelevel2_itemContainer_textContainer_title: {

  },
  hcommerce_storelevel2_itemContainer_textContainer_subtitle: {

  },
  hcommerce_storelevel2_itemContainer_textContainer_tertiaryContainer: {

  },
  hcommerce_storelevel2_itemContainer_arrow: {

  },

  /** Store level 2 landscape */

  hcommerce_storelevel2_landscape_item_image: {
    objectFit: "cover",
    borderRadius: 10
  },

  hcommerce_storelevel2_landscape_MainContainer: {
    flex: 1
  },

  hcommerce_storelevel2_landscape_HeaderContainer: {

  },
  hcommerce_storelevel2_landscape_HeaderImg: {
    display: "none"
  },
  hcommerce_storelevel2_landscape_HeaderTitleContainer: {
    alignItems: "start"
  },
  hcommerce_storelevel2_landscape_HeaderTitle: {
    textTransform: null,
    textAlign: "left"
  },
  hcommerce_storelevel2_landscape_HeaderSubTitle: {
    textAlign: "left",
    paddingLeft: 0
  },

  hcommerce_storelevel2_landscape_MainContainerChildContainer: {
    flex: undefined,
    paddingBottom: 148
  },
  hcommerce_storelevel2_landscape_ChildContainer_items_container: {
    gap: 16,
    flexDirection: "row",
    flexWrap: "wrap"
  },
  hcommerce_storelevel2_landscape_itemContainer: {
    height: 280,
    width: 220,
    borderRadius: 5,
    borderWidth: 1,
    padding: 16,
    gap: 12,
    borderColor: "rgba(0,0,0,0.2)",
    flexDirection: "column",

    alignItems: "flex-start",

    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.2,
    shadowRadius: 4,
  },
  hcommerce_storelevel2_landscape_itemContainer_image: {
    height: 140,
    width: 188,
    borderRadius: 5
  },
  hcommerce_storelevel2_landscape_itemContainer_textContainer: {
    width: "100%"
  },
  hcommerce_storelevel2_landscape_itemContainer_textContainer_title: {

  },
  hcommerce_storelevel2_landscape_itemContainer_textContainer_subtitle: {

  },
  hcommerce_storelevel2_landscape_itemContainer_arrow: {

  },



  hcommerce_iteminfo_container: {
    maxHeight: 666,
    minHeight: 500,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    overflow: "hidden",
    backgroundColor: COLORS.PRIMARY_COLOR,
  },
  hcommerce_iteminfo_mainContainer: {
    paddingBottom: 20
  },
  hcommerce_iteminfo_HeaderContainer: {

  },
  hcommerce_iteminfo_HeaderImg: {

  },
  hcommerce_iteminfo_HeaderTitleContainer: {
    paddingTop: 48
  },
  hcommerce_iteminfo_HeaderTitle: {

  },
  hcommerce_iteminfo_HeaderSubTitle: {

  },

  hcommerce_iteminfo_MainContainerChildContainer: {
    gap: 24
  },

  hcommerce_iteminfo_MainContainerChildContainer_amount_container: {
    display: "flex",
    flexDirection: 'row',
    width: "100%",
    alignItems: "center",
    justifyContent: 'space-between'
  },
  hcommerce_iteminfo_MainContainerChildContainer_amount_container_text: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR
  },






  additem_controls: {
    display: "flex",
    flexDirection: "row",
    alignItems: 'center',
    gap: 16,
  },
  additem_controls_sub_container: {
    
  },
  additem_controls_sub_container_img: {
    width: 24,
    height: 24,
  },
  additem_controls_qty_text: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },


  additem_controls2: {
    display: "flex",
    flexDirection: "row",
    alignItems: 'center',
    gap: 16,
  },
  additem_controls_sub_container2: {
    padding: 8,
    backgroundColor: COLORS.SECONDARY_COLOR,
  },
  additem_controls_sub_container_img2: {
    width: 20,
    height: 20,
    tintColor: COLORS.SECONDARY_TEXT_COLOR,
    filter: "invert(1)"
  },
  additem_controls_qty_text2: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  /** */
  showMoreButtonText: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },

  /**
   * Add Items Constrol LAndscape
   */
  additem_controls_landscape: {
    display: "flex",
    flexDirection: "row",
    alignItems: 'center',
    gap: 16,
  },
  additem_controls_landscape_sub_container: {
    
  },
  additem_controls_landscape_sub_container_img: {
    width: 24,
    height: 24,
  },
  additem_controls_landscape_qty_text: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },


  additem_controls_landscape2: {
    display: "flex",
    flexDirection: "row",
    alignItems: 'center',
    gap: 16,
  },
  additem_controls_landscape_sub_container2: {
    padding: 8,
    backgroundColor: COLORS.SECONDARY_COLOR,
  },
  additem_controls_landscape_sub_container_img2: {
    width: 20,
    height: 20,
    tintColor: COLORS.SECONDARY_TEXT_COLOR,
    filter: "invert(1)"
  },
  additem_controls_landscape_qty_text2: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },



  // H COMMERCE - UpdateItemAddOns
  AddOnsModalContent: {
    maxHeight: 666,
    height: "100%",
    minHeight: 610,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingBottom: 40,
    justifyContent: "flex-start",
    backgroundColor: COLORS.PRIMARY_COLOR,
  },
  AddOnsModalContent_maincontainer: {

  },
  AddOnsModalContent_childcontainer_header_container: {
    height: 'auto',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 8,
    paddingTop: 16
  },
  AddOnsModalContent_childcontainer_header_container_title: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  AddOnsModalContent_childcontainer_header_container_subtitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR
  },

  AddOnsModalContent_childcontainer: {
    paddingHorizontal: 24,
    gap: 24,
    maxHeight: 300
  },

  AddOnsModalContent_addons_main_container: {
    gap: 8,
    height: 350
  },
  AddOnsModalContent_addons_child_container: {
    gap: 8,
  },
  AddOnsModalContent_addons_itemContainer: {
    
  },
  AddOnsModalContent_addons_itemContainer_image: {

  },
  AddOnsModalContent_addons_itemContainer_textContainer: {
    height: "auto"
  },
  AddOnsModalContent_addons_itemContainer_textContainer_title: {
    
  },
  AddOnsModalContent_addons_itemContainer_textContainer_subtitle: {

  },
  AddOnsModalContent_addons_itemContainer_textContainer_price: {

  },


  AddOnsModalContent_childcontainer_quantity_container: {
    display: "flex",
    flexDirection: 'row',
    width: "100%",
    alignItems: "center",
    justifyContent: 'space-between'
  },
  AddOnsModalContent_childcontainer_quantity_container_text: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR
  },

  // H COMMERCE - AddOnPopupWithGrouping
  AddOnGrouping_drawer_header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  AddOnGrouping_drawer_icon: {
    width: 20,
    height: 20,
    tintColor: COLORS.PRIMARY_TEXT_COLOR
  },
  AddOnGrouping_drawer_header_title: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    fontWeight: '700',
  },
  AddOnGrouping_drawer_header_subtitle: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    opacity: 0.6,
  },

  // H COMMERCE - shared modal styles (ItemGroupedAddonsModal + ItemAddOnsModal)
  hcommerce_modal_sheet: {
    backgroundColor: COLORS.WHITE,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
  },
  hcommerce_modal_closeAboveContainer: {
    alignItems: 'center',
    marginBottom: 10,
  },
  hcommerce_modal_closeAboveBtn: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: '#00000080',
    alignItems: 'center',
    justifyContent: 'center',
  },
  hcommerce_modal_closeAboveIcon: {
    width: 18,
    height: 18,
    tintColor: COLORS.WHITE,
  },
  hcommerce_modal_dragIndicatorWrap: {
    alignItems: 'center',
    paddingTop: 10,
    paddingBottom: 4,
  },
  hcommerce_modal_dragIndicator: {
    width: 40,
    height: 4,
    borderRadius: 2,
    backgroundColor: 'rgba(0,0,0,0.18)',
  },
  hcommerce_modal_scroll: {
    flexShrink: 1,
  },
  hcommerce_modal_scrollContent: {
    paddingHorizontal: 16,
    paddingTop: 16,
  },
  hcommerce_modal_scrollContentFlat: {
    paddingHorizontal: 20,
    paddingTop: 16,
  },
  hcommerce_modal_imageContainer: {
    width: '100%',
    height: 180,
    borderRadius: 12,
    overflow: 'hidden',
    marginBottom: 16,
  },
  hcommerce_modal_image: {
    width: '100%',
    height: '100%',
  },
  hcommerce_modal_itemInfo: {
    alignItems: 'center',
    marginBottom: 12,
    paddingHorizontal: 8,
  },
  hcommerce_modal_itemInfoFlat: {
    alignItems: 'center',
    marginBottom: 8,
  },
  hcommerce_modal_itemName: {
    textAlign: 'center',
    marginBottom: 4,
  },
  hcommerce_modal_itemPrice: {
    textAlign: 'center',
    marginBottom: 8,
  },
  hcommerce_modal_descClamp: {
    maxHeight: 44,
    overflow: 'hidden',
  },
  hcommerce_modal_showMoreBtnText: {
    textAlign: 'center',
    fontSize: 13,
    color: COLORS.ACCENT_COLOR,
    marginTop: 4,
    fontWeight: '600',
  },
  hcommerce_modal_footer: {
    paddingHorizontal: 16,
    paddingTop: 12,
    paddingBottom: 8,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: 'rgba(0,0,0,0.1)',
  },
  hcommerce_modal_footerFlat: {
    paddingHorizontal: 20,
    paddingTop: 12,
    paddingBottom: 8,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: 'rgba(0,0,0,0.1)',
  },
  hcommerce_modal_footerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  hcommerce_modal_footerRowFlat: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  hcommerce_modal_qtyBlock: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.15)',
    borderRadius: 10,
    paddingHorizontal: 8,
    paddingVertical: 6,
  },
  hcommerce_modal_qtyBlockFlat: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  hcommerce_modal_qtyBtn: {
    width: 30,
    height: 30,
    borderRadius: 15,
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.15)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  hcommerce_modal_qtyBtnFlat: {
    width: 36,
    height: 36,
    borderRadius: 18,
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.2)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  hcommerce_modal_qtyIcon: {
    width: 14,
    height: 14,
  },
  hcommerce_modal_qtyIconFlat: {
    width: 16,
    height: 16,
  },
  hcommerce_modal_addBtnFlex: {
    flex: 1,
  },
  hcommerce_modal_bottomPad: {
    height: 20,
  },
  hcommerce_modal_instructionsInput: {
    marginTop: 10,
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.15)',
    borderRadius: 8,
    padding: 12,
    minHeight: 80,
    fontSize: 14,
    lineHeight: 20,
  },
  
  hcommerce_modal_landscape: {
    height: "100%",
    width: "100%"
  },
  // Neutral wrapper — no-op in portrait, right-column in landscape
  hcommerce_modal_contentContainer: {},
  hcommerce_modal_rightColumn: {
  },
  // iPad landscape: image left panel + right column
  hcommerce_modal_sheet_landscape: {
    backgroundColor: COLORS.WHITE,
    borderRadius: 20,
    width: '100%',
    height: '85%',
    flexDirection: 'row',
    overflow: 'hidden',
  },
  hcommerce_modal_imageContainer_landscape: {
    width: '45%',
    alignSelf: 'stretch',
    overflow: 'hidden',
  },

  // H COMMERCE - ItemGroupedAddonsModal specific
  hcommerce_grouped_groupCard: {
    marginTop: 12,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.1)',
    overflow: 'hidden',
  },
  hcommerce_grouped_groupCardRequired: {
    borderLeftWidth: 3,
    borderLeftColor: COLORS.ACCENT_COLOR,
  },
  hcommerce_grouped_groupHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 14,
    paddingVertical: 12,
    backgroundColor: 'rgba(0,0,0,0.02)',
  },
  hcommerce_grouped_groupHeaderText: {
    flex: 1,
    paddingRight: 8,
  },
  hcommerce_grouped_groupTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 6,
    marginBottom: 2,
  },
  hcommerce_grouped_groupDivider: {
    height: StyleSheet.hairlineWidth,
    backgroundColor: 'rgba(0,0,0,0.1)',
  },
  hcommerce_grouped_groupContent: {
    paddingHorizontal: 14,
  },
  hcommerce_grouped_badge: {
    borderRadius: 4,
    paddingHorizontal: 6,
    paddingVertical: 2,
  },
  hcommerce_grouped_badgeText: {
    fontSize: 11,
    fontWeight: '600',
  },
  hcommerce_grouped_requiredBadge: {
    backgroundColor: 'rgba(189,38,17,0.1)',
  },
  hcommerce_grouped_requiredBadgeText: {
    color: COLORS.ACCENT_COLOR,
  },
  hcommerce_grouped_optionalBadge: {
    backgroundColor: 'rgba(0,0,0,0.06)',
  },
  hcommerce_grouped_optionalBadgeText: {
    color: 'rgba(0,0,0,0.5)',
  },
  hcommerce_grouped_addonRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 12,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: 'rgba(0,0,0,0.06)',
  },
  hcommerce_grouped_nestedAddonRow: {
    paddingVertical: 10,
  },
  hcommerce_grouped_addonRowLeft: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 8,
  },
  hcommerce_grouped_addonText: {
    flex: 1,
    marginRight: 8,
  },
  hcommerce_grouped_parentSelectionHint: {
    fontSize: 12,
    color: 'rgba(0,0,0,0.45)',
    marginTop: 2,
  },
  hcommerce_grouped_nestedContainer: {
    marginLeft: 12,
    borderLeftWidth: 2,
    borderLeftColor: 'rgba(0,0,0,0.1)',
    paddingLeft: 10,
    marginBottom: 4,
  },
  hcommerce_grouped_nestedGroupBlock: {
    backgroundColor: 'rgba(0,0,0,0.03)',
    borderRadius: 8,
    padding: 10,
    marginTop: 6,
  },
  hcommerce_grouped_nestedGroupHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 4,
  },
  hcommerce_grouped_nestedGroupName: {
    flex: 1,
    fontWeight: '600',
  },
  hcommerce_grouped_nestedGroupDesc: {
    marginBottom: 6,
    opacity: 0.65,
  },
  hcommerce_grouped_emptyText: {
    fontStyle: 'italic',
    marginTop: 4,
    opacity: 0.5,
  },
  hcommerce_grouped_instructionsSection: {
    marginTop: 16,
    paddingTop: 14,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: 'rgba(0,0,0,0.08)',
  },

  // H COMMERCE - ItemAddOnsModal specific
  hcommerce_flat_groupSection: {
    marginTop: 18,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: 'rgba(0,0,0,0.08)',
    paddingTop: 14,
  },
  hcommerce_flat_groupHeader: {
    marginBottom: 8,
  },
  hcommerce_flat_addonRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 12,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: 'rgba(0,0,0,0.06)',
  },
  hcommerce_flat_addonRowLeft: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 12,
  },
  hcommerce_flat_addonImage: {
    width: 44,
    height: 44,
    borderRadius: 8,
    overflow: 'hidden',
    marginRight: 12,
  },
  hcommerce_flat_addonText: {
    flex: 1,
  },

  // H COMMERCE - Repeat choice sheet (index.js)
  hcommerce_repeat_overlay: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'flex-end',
    zIndex: 999,
  },
  hcommerce_repeat_backdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0,0,0,0.45)',
  },
  hcommerce_repeat_sheet: {
    backgroundColor: COLORS.WHITE,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    paddingBottom: 28,
  },
  hcommerce_repeat_sheetHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingVertical: 16,
  },
  hcommerce_repeat_sheetTitle: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    fontSize: 16,
    fontWeight: '700',
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  hcommerce_repeat_sheetClose: {
    padding: 4,
  },
  hcommerce_repeat_sheetCloseText: {
    fontSize: 18,
    color: 'rgba(0,0,0,0.5)',
  },
  hcommerce_repeat_divider: {
    height: StyleSheet.hairlineWidth,
    backgroundColor: 'rgba(0,0,0,0.1)',
  },
  hcommerce_repeat_entryRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingVertical: 14,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: 'rgba(0,0,0,0.07)',
  },
  hcommerce_repeat_entryInfo: {
    flex: 1,
    paddingRight: 12,
  },
  hcommerce_repeat_entryTitle: {
    ...SECONDARY_FONT,
    fontSize: 14,
    fontWeight: '600',
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginBottom: 2,
  },
  hcommerce_repeat_entryAddons: {
    ...SECONDARY_FONT,
    fontSize: 12,
    color: 'rgba(0,0,0,0.5)',
  },
  hcommerce_repeat_entryRight: {
    alignItems: 'flex-end',
    gap: 4,
  },
  hcommerce_repeat_entryQtyRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  hcommerce_repeat_qtyBtn: {
    width: 30,
    height: 30,
    borderRadius: 15,
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.2)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  hcommerce_repeat_qtyBtnText: {
    fontSize: 18,
    lineHeight: 22,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  hcommerce_repeat_qtyNum: {
    ...SECONDARY_FONT,
    fontSize: 15,
    fontWeight: '700',
    minWidth: 20,
    textAlign: 'center',
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  hcommerce_repeat_entryPrice: {
    ...SECONDARY_FONT,
    fontSize: 13,
    color: 'rgba(0,0,0,0.55)',
  },
  hcommerce_repeat_addNewBtn: {
    paddingVertical: 16,
    alignItems: 'center',
  },
  hcommerce_repeat_addNewBtnText: {
    ...PRIMARY_FONT,
    fontSize: 15,
    fontWeight: '600',
    color: COLORS.ACCENT_COLOR,
  },

  AddOnsWithGroupingModalContent_childcontainer: {
    maxHeight: 350
  },


  myOrder_container: {

  },
  myOrder_container_price_container: {
    display: "flex",
    flexDirection: 'row',
    width: "100%",
    alignItems: "center",
    justifyContent: 'space-between'
  },
  myOrder_container_price_container_text: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  myOrder_container_count_container: {
    display: "flex",
    width: 20,
    height: 20,
    borderRadius: 10,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: 'center',
    backgroundColor: COLORS.ACCENT_COLOR
  },
  myOrder_container_count_container_text: {
    ...SECONDARY_FONT,
    color: COLORS.ACCENT_Text_COLOR
  },


  hcommerce_orderdetails_MainContainer: {

  },

  hcommerce_orderdetails_HeaderContainer: {

  },
  hcommerce_orderdetails_HeaderTitleContainer: {

  },
  hcommerce_orderdetails_HeaderTitle: {

  },
  hcommerce_orderdetails_HeaderSubTitle: {

  },

  hcommerce_orderdetails_HeaderOrderDetailsContainer: {
    maxHeight: 350,
    borderRadius: 12,
    overflow: 'hidden'
  },
  hcommerce_orderdetails_itemContainer: {
    paddingHorizontal: 16
  },
  hcommerce_orderdetails_itemContainer_image: {

  },
  hcommerce_orderdetails_itemContainer_textContainer: {

  },
  hcommerce_orderdetails_itemContainer_textContainer_title: {

  },
  hcommerce_orderdetails_itemContainer_textContainer_subtitle: {

  },
  hcommerce_orderdetails_itemContainer_textContainer_tertiaryContainer: {

  },


  hcommerce_orderdetails_MainContainerChildContainer: {
    gap: 16
  },
  hcommerce_orderdetails_MainContainerChildContainer_titlecontainer: {
    gap: 8,
    paddingTop: 48,
    paddingHorizontal: 16
  },
  hcommerce_orderdetails_MainContainerChildContainer_title: {
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    textTransform: "uppercase",
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  hcommerce_orderdetails_MainContainerChildContainer_subtitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: "center",
    paddingHorizontal: 24,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },


  hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: 'center',
    padding: 16,
    gap: 8
  },
  hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container: {
    display: 'flex',
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: 'flex-end',
    width: "100%"
  },
  hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_price: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },

  hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_gratitude_top_container: {
    display: 'flex',
    justifyContent: "space-between",
    alignItems: 'flex-end',
    width: "100%",
    marginTop: 8
  },

  gratitude_container: {
    width: "100%",
    marginTop: 8
  },
  gratitude_Slider: {
    width: "100%",
  },

  hcommerce_orderdetails_MainContainerChildContainer_buttonContainer: {
    gap: 8,
    paddingBottom: 40,
    position: "sticky",
    backgroundColor: COLORS.BACKGROUND_COLOR,
    bottom: 0,
    padding: 24
  },

  hcommerce_orderdetails_HeaderImg: {
    display: "none"
  },

  // Toast pricing loader styles
  hcommerce_orderdetails_pricing_loader_container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    gap: 12
  },
  hcommerce_orderdetails_pricing_loader_text: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: 'center'
  },

  // Toast pricing error styles
  hcommerce_orderdetails_pricing_error_container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    gap: 16,
    backgroundColor: 'rgba(189, 38, 17, 0.05)',
    borderRadius: 8,
    margin: 16
  },
  hcommerce_orderdetails_pricing_error_text: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.ACCENT_COLOR,
    textAlign: 'center',
    maxWidth: '80%'
  },
  hcommerce_orderdetails_pricing_retry_btn: {
    paddingHorizontal: 24,
    paddingVertical: 12,
    backgroundColor: COLORS.ACCENT_COLOR,
    borderRadius: 8,
    marginTop: 8
  },
  hcommerce_orderdetails_pricing_retry_text: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.WHITE,
    textAlign: 'center',
    fontWeight: '600'
  },



  /*guest request */
  guestrequest_RootContainer: {

  },
  guestrequest_MainContainer: {
    paddingBottom: 148
  },

  guestrequest_HeaderContainer: {

  },
  guestrequest_HeaderImg: {

  },
  guestrequest_HeaderTitleContainer: {

  },
  guestrequest_HeaderTitle: {

  },
  guestrequest_HeaderSubTitle: {

  },

  guestrequest_MainContainerChildContainer: {
    paddingHorizontal: 0,
  },
  guestrequest_ChildTitleContainer:{
    marginHorizontal: 16,
    marginBottom: 16
  },
  guestrequest_ChildTitle:{

  },

  guestrequest_childcontainer_itemContainer: {
    paddingHorizontal: 16,
  },
  guestrequest_childcontainer_itemContainer_image: {

  },
  guestrequest_childcontainer_itemContainer_textContainer: {

  },
  guestrequest_childcontainer_itemContainer_textContainer_title: {

  },
  guestrequest_childcontainer_itemContainer_textContainer_subtitle: {

  },
  guestrequest_childcontainer_itemContainer_arrow: {

  },
  guestrequest_childcontainer_itemContainer_arrow_img: {

  },

  guestrequest_childcontainer_itemContainer_selected: {
    backgroundColor: COLORS.ACCENT_COLOR
  },
  guestrequest_childcontainer_itemContainer_image_selected: {

  },
  guestrequest_childcontainer_itemContainer_textContainer_selected: {

  },
  guestrequest_childcontainer_itemContainer_textContainer_title_selected: {
    color: COLORS.ACCENT_Text_COLOR
  },
  guestrequest_childcontainer_itemContainer_textContainer_subtitle_selected: {
    color: COLORS.ACCENT_Text_COLOR
  },
  guestrequest_childcontainer_itemContainer_arrow_selected: {

  },
  guestrequest_childcontainer_itemContainer_arrow_img_selected: {
    tintColor: COLORS.ACCENT_Text_COLOR,
    filter: "invert(1)"
  },
  guestrequest_button_container: {

  },

  /** guest request landscape */
  guestrequest_landscape_RootContainer: {

  },
  guestrequest_landscape_MainContainer: {
    // paddingBottom: 148,
    paddingHorizontal: 30,
    flexGrow: null
  },

  guestrequest_landscape_HeaderContainer: {

  },
  guestrequest_landscape_HeaderImg: {
    display: "none"
  },
  guestrequest_landscape_HeaderTitleContainer: {
    alignItems: "flex-start",
    paddingLeft: 0,
    paddingBottom: 30,
  },
  guestrequest_landscape_HeaderTitle: {
    textAlign: "left",
  },
  guestrequest_landscape_HeaderSubTitle: {
    alignItems: "flex-start"
  },

  guestrequest_landscape_MainContainerChildContainer: {
    paddingLeft: 0,
    paddingRight: 0,
    flexWrap: null,
    flexDirection: "column",
    flex: 1,
    gap: 40,
  },
  guestrequest_landscape_ChildTitleContainer:{
    marginBottom: 16
  },
  guestrequest_landscape_ChildTitle:{
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  guestrequest_landscape_list_container: {
    flexDirection: "row", 
    flexWrap: "wrap", 
    gap: 16
  },
  guestrequest_landscape_NonArrayItemContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 16,
  },
  guestrequest_landscape_childcontainer_itemContainer: {
    paddingHorizontal: 16,
    paddingVertical: 8,

    borderRadius: 5,
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.2)",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,

    width: "31%",
    height: 80
  },
  guestrequest_landscape_childcontainer_itemContainer_image: {
    display: "none",
  },
  guestrequest_landscape_childcontainer_itemContainer_textContainer: {

  },
  guestrequest_landscape_childcontainer_itemContainer_textContainer_title: {
    ...FONT_MEDIUM,
    textTransform: "none"
  },
  guestrequest_landscape_childcontainer_itemContainer_textContainer_subtitle: {
    display: "none"
  },
  guestrequest_landscape_childcontainer_itemContainer_arrow: {

  },
  guestrequest_landscape_childcontainer_itemContainer_arrow_img: {

  },

  guestrequest_landscape_childcontainer_itemContainer_selected: {
    backgroundColor: COLORS.ACCENT_COLOR
  },
  guestrequest_landscape_childcontainer_itemContainer_image_selected: {

  },
  guestrequest_landscape_childcontainer_itemContainer_textContainer_selected: {

  },
  guestrequest_landscape_childcontainer_itemContainer_textContainer_title_selected: {
    color: COLORS.ACCENT_Text_COLOR
  },
  guestrequest_landscape_childcontainer_itemContainer_textContainer_subtitle_selected: {
    color: COLORS.ACCENT_Text_COLOR
  },
  guestrequest_landscape_childcontainer_itemContainer_arrow_selected: {

  },
  guestrequest_landscape_childcontainer_itemContainer_arrow_img_selected: {
    tintColor: COLORS.ACCENT_Text_COLOR,
    filter: "invert(1)"
  },
  guestrequest_landscape_button_container: {

  },

  /** Guest request details  */

  guestrequestdetails_RootContainer: {

  },
  guestrequestdetails_MainContainer: {
    flexGrow: 1,
    height: "100%"
  },
  guestrequestdetails_HeaderContainer: {

  },
  guestrequestdetails_HeaderTitleContainer: {
    paddingBottom: 30,
  },
  guestrequestdetails_HeaderTitle: {

  },
  guestRequestDetailsFooterCotainer: {
    padding: 16,
    gap: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },

  guestrequestdetails_itemContainer: {
    // padding: 16,
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.2)",
    // shadowColor: "rgba(0, 0, 0, 0.2)",
  },
  guestrequestdetails_itemContainer_image: {

  },
  guestrequestdetails_itemContainer_textContainer: {
    flex: null,
    maxWidth: "80%",
    height: "auto"
  },
  guestrequestdetails_itemContainer_textContainer_title: {

  },
  guestrequestdetails_textContainer_subtitle: {

  },
  guestrequestdetails_itemContainer_arrow: {

  },
  guestrequestdetails_itemContainer_arrow_img: {
    tintColor: COLORS.PRIMARY_TEXT_COLOR,
    filter: "invert(1)"
  },

  guestrequestdetails_MainContainerChildContainer: {
    maxHeight: 250,
    shadowColor: "rgba(0, 0, 0, 0.2)",
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    zIndex: 1,
  },

  guestrequestdetails_buttonContainer: {
    gap: 8,
    paddingBottom: 40,
    position: "sticky",
    backgroundColor: COLORS.BACKGROUND_COLOR,
    bottom: 0,
    padding: 24
  },

  /** Guest Request Details Landscape */
  guestrequestdetails_landscape_RootContainer: {

  },
  guestrequestdetails_landscape_MainContainer: {
    flexGrow: 1,
    height: "100%"
  },
  guestrequestdetails_landscape_HeaderContainer: {

  },
  guestrequestdetails_landscape_HeaderTitleContainer: {
    
  },
  guestrequestdetails_landscape_HeaderTitle: {

  },
  guestrequestdetails_landscapeFooterCotainer: {
    padding: 16,
    gap: 16,
  },

  guestrequestdetails_landscape_itemContainer: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    backgroundColor: COLORS.ACCENT_COLOR,

    borderRadius: 5,
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.2)",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    width: 300,
    height: 80
  },
  guestrequestdetails_landscape_itemContainer_image: {
    display: "none",
  },
  guestrequestdetails_landscape_item_image: {
    height: "100%",
    width: "100%",
    objectFit: "cover",
  },
  guestrequestdetails_landscape_itemContainer_textContainer: {
    
  },
  guestrequestdetails_landscape_itemContainer_textContainer_title: {
    ...FONT_MEDIUM,
    textTransform: "none",
    color: COLORS.ACCENT_Text_COLOR
  },
  guestrequestdetails_landscape_textContainer_subtitle: {
    color: COLORS.ACCENT_Text_COLOR,
    display: "none"
  },
  guestrequestdetails_landscape_itemContainer_arrow: {

  },
  guestrequestdetails_landscape_itemContainer_arrow_img: {
  },

  guestrequestdetails_landscape_MainContainerChildContainer: {
    marginTop: 16,
    shadowColor: "rgba(0, 0, 0, 0.2)",
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    zIndex: 1,

    flex: null,
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 16
  },

  guestrequestdetails_landscape_buttonContainer: {
    gap: 8,
    paddingBottom: 40,
    position: "sticky",
    backgroundColor: COLORS.BACKGROUND_COLOR,
    bottom: 0,
    padding: 24
  },

  // View Bill------->
  billContainer: {
    padding: 20,
  },
  intervalError: {
    fontWeight: '400',
    alignSelf: 'center',
    textAlign: 'center',
    top: 10,
    ...SECONDARY_FONT,
    ...FONT_LARGE,
  },
  billHeaderTitle: {
    fontWeight: '400',
    textAlign: 'center',
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  billHeaderSubTitle: {
    textAlign: 'center',
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  viewBill_Item_textContentContainer: {
    gap: 16
  },

  detailsContainer: {
    marginTop: 10,
  },
  detailsContainerTitle: {
    textAlign: 'center',
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginTop: 20,
    textTransform: 'uppercase'
  },
  purcharseBillText: {
    fontWeight: '400',
    textAlign: 'center',
    alignSelf: 'center',
    fontSize: 25,
    ...SECONDARY_FONT,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  guestItineraryDetailsHeaderTitle:{
    ...FONT_MEDIUM,
  },

  guestItineraryDetails_subHeading:{
    textAlign: "center",
    ...PRIMARY_FONT,
    ...FONT_SMALL,
  },


  guestItineraryDetails_bodyText: {
    textAlign: "center",
    ...SECONDARY_FONT,
    ...FONT_SMALL,
  },
  


  reviewBill: {
    fontWeight: '400',
    textAlign: 'center',
    alignSelf: 'center',
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  viewbillMainContainer: {
    paddingBottom: 90
  },
  viewBillDateContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: 'space-between',
    marginVertical: 24,
    gap: 8,
  },
  viewBillDateItemContainer: {
    flex: 1,
    width: "auto",
    borderWidth: 0.5,
    borderColor: COLORS.ACCENT_COLOR,
    paddingVertical: 16,
    paddingHorizontal: 10
  },
  viewBillDateItemTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    fontWeight: '400',
    textAlign: 'center',
    alignSelf: 'center',
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  viewBillDateItemSubTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    fontWeight: '400',
    textAlign: 'center',
    alignSelf: 'center',
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  billCheckoutBtnContainer: {
    bottom: 0,
    width: '100%',
    position: 'absolute',
    padding: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR,
    gap: 10,
  },
  historyContainer: {
    marginTop: 40

  },
  ViewBill_itemContainer_textContainer_noHistory_container: {
    alignItems: "center",
    justifyContent: "center",
    height: null,
    paddingBottom: 20,
  },
  ViewBill_itemContainer_textContainer_noHistory: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: 'center',
  },
  viewBill_Item_textContainer: {
    borderBottomWidth: 1,
    paddingHorizontal: 10,
    paddingVertical: 0,
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  ViewBill_itemContainer_textContainer_title:{
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "left",
  },
  ViewBill_itemContainer_textContainer_subtitle: {

  },
  viewBill_infoModalRowView:{
    flexDirection: 'row', 
    justifyContent: 'space-evenly', 
    marginVertical: 10
  },
  viewBill_infoModalSubheader:{
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginBottom: 15,
    textAlign: 'center'
  },
  viewBill_infoModalTitle:{
    ...SECONDARY_FONT,
    ...FONT_XLARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: 'uppercase',
    textAlign: "center",
    paddingVertical: 8
  },
  viewBillConfirmCheckoutHeaderContainer: {
    justifyContent: "center",
    alignItems: "center",
    height: "100%"
  },
  viewBillConfirmCheckoutMainContainerHeaderImg: {
    height: 55,
    width: 55,
    margin: null
  },

  infoModalRowView: { flexDirection: 'row', justifyContent: 'space-evenly', marginVertical: 10 },
  // title: {
  //   fontSize: 35,
  //   fontWeight: 'bold',
  //   textAlign: 'center',
  //   marginVertical: 10,
  //   color: SELECTOR_COL_SECONDARY,
  // },
  total: {
    textAlign: 'center',
    marginTop: 15,
    color: COLORS.PRIMARY_TEXT_COLOR,
    ...SECONDARY_FONT,
    fontSize: 20,
  },
  amount: {
    textAlign: 'center',
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginBottom: 10,
    ...SECONDARY_FONT,
    fontSize: 35,
  },

  date: {
    fontSize: 14,
    fontWeight: '500',
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  roomChargesTitle: {
    fontSize: 25,
    fontWeight: 'bold',
    marginTop: 20,
    marginVertical: 15,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  billItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 5,
    paddingVertical: 20,
    marginHorizontal: 15,
    paddingHorizontal: 13,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    padding: 5,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  billDescription: {
    fontSize: 16,
    color: COLORS.PRIMARY_TEXT_COLOR,
    fontWeight: '500',
    width: '70%',
  },
  billAmount: {
    fontSize: 16,
    color: COLORS.PRIMARY_TEXT_COLOR,
    fontWeight: '600',
    width: '30%',
    textAlign: 'right',
  },


  /** View Bill Landscape */
  billContainer_landscape: {
    padding: 20,
    paddingHorizontal: 0
  },
  intervalError_landscape: {
    fontWeight: '400',
    alignSelf: 'center',
    textAlign: 'center',
    top: 10,
    ...SECONDARY_FONT,
    ...FONT_LARGE,
  },
  billHeaderTitle_landscape: {
    fontWeight: '400',
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  billHeaderSubTitle_landscape: {
    textAlign: 'center',
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  viewBill_Item_textContentContainer_landscape: {
    paddingHorizontal: 30,
    flexWrap: "wrap", 
    flexDirection: "row",
    gap: 16
  },

  detailsContainer_landscape: {
    marginTop: 10,
  },
  detailsContainerTitle_landscape: {
    textAlign: 'center',
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginTop: 20,
    textTransform: 'uppercase'
  },
  purcharseBillText_landscape: {
    fontWeight: '400',
    fontSize: 25,
    ...SECONDARY_FONT,
    color: COLORS.PRIMARY_TEXT_COLOR,
    alignSelf: null
  },

  guestItineraryDetailsHeaderTitle_landscape:{
    ...FONT_MEDIUM,
  },

  guestItineraryDetails_subHeading_landscape:{
    textAlign: "center",
    ...PRIMARY_FONT,
    ...FONT_SMALL,
  },


  guestItineraryDetails_bodyText_landscape: {
    textAlign: "center",
    ...SECONDARY_FONT,
    ...FONT_SMALL,
  },
  


  reviewBill_landscape: {
    fontWeight: '400',
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  viewbillMainContainer_landscape: {
    paddingBottom: 90
  },
  viewBillDateContainer_landscape: {
    maxWidth: "50%",
    display: "flex",
    flexDirection: "row",
    justifyContent: 'space-between',
    marginVertical: 24,
    gap: 8,
  },
  viewBillDateItemContainer_landscape: {
    flex: 1,
    width: "auto",
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 0.5,
    borderColor: COLORS.ACCENT_COLOR,
    paddingVertical: 16,
    paddingHorizontal: 10
  },
  billTotalcontainer_landscape: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 16,
  },
  viewBillPrimaryBtn_landscape: {
    width: "auto",
    flex: 1
  },

  viewBillSecondaryBtn_landscape: {
    flex: 1,
    borderWidth: 1,
    borderColor: COLORS.SECONDARY_COLOR
  },
  viewBillSecondaryBtnTxt_landscape: {
    color: COLORS.SECONDARY_COLOR
  },
  ViewBillWidgetHeaderImg_landscape: {
    display: "none"
  },
  viewBillDateItemTitle_landscape: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    fontWeight: '400',
    textAlign: 'center',
    alignSelf: 'center',
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  viewBillDateItemSubTitle_landscape: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    fontWeight: '400',
    textAlign: 'center',
    alignSelf: 'center',
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  billCheckoutBtnContainer_landscape: {
    bottom: 0,
    width: '100%',
    position: 'absolute',
    padding: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR,
    gap: 10,
  },
  historyContainer_landscape: {
    marginTop: 40

  },
  ViewBill_itemContainer_textContainer_noHistory_container_landscape: {
    alignItems: "center",
    justifyContent: "center",
    height: null,
    paddingBottom: 20,
  },
  ViewBill_itemContainer_textContainer_noHistory_landscape: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: 'center',
  },
  viewBill_Item_textContainer_landscape: {
    borderWidth: 1,
    paddingHorizontal: 30,
    paddingVertical: 0,
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  ViewBill_itemContainer_textContainer_title_landscape:{
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "left",
  },
  ViewBill_itemContainer_textContainer_subtitle_landscape: {

  },
  viewBill_infoModalRowView_landscape:{
    flexDirection: 'row', 
    justifyContent: 'space-evenly', 
    marginVertical: 10
  },
  viewBill_infoModalSubheader_landscape:{
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginBottom: 15,
    textAlign: 'center'
  },
  viewBill_infoModalTitle_landscape:{
    ...SECONDARY_FONT,
    ...FONT_XLARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: 'uppercase',
    textAlign: "center",
    paddingVertical: 8
  },
  viewBillConfirmCheckoutHeaderContainer_landscape: {
    justifyContent: "center",
    alignItems: "center",
    height: "100%"
  },
  viewBillConfirmCheckoutMainContainerHeaderImg_landscape: {
    height: 55,
    width: 55,
    margin: null
  },

  infoModalRowView_landscape: { 
    flexDirection: 'row', 
    justifyContent: 'space-evenly', 
    marginVertical: 10 
  },
  total_landscape: {
    marginTop: 15,
    color: COLORS.PRIMARY_TEXT_COLOR,
    ...SECONDARY_FONT,
    fontSize: 20,
  },
  amount_landscape: {
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginBottom: 10,
    ...SECONDARY_FONT,
    fontSize: 35,
  },

  date_landscape: {
    fontSize: 14,
    fontWeight: '500',
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  roomChargesTitle_landscape: {
    fontSize: 25,
    fontWeight: 'bold',
    marginTop: 20,
    marginVertical: 15,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  billItem_landscape: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 5,
    paddingVertical: 20,
    marginHorizontal: 15,
    paddingHorizontal: 13,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    padding: 5,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  billDescription_landscape: {
    fontSize: 16,
    color: COLORS.PRIMARY_TEXT_COLOR,
    fontWeight: '500',
    width: '70%',
  },
  billAmount_landscape: {
    fontSize: 16,
    color: COLORS.PRIMARY_TEXT_COLOR,
    fontWeight: '600',
    width: '30%',
    textAlign: 'right',
  },



  /**
   *
   * LOADER
   *
   */
  loaderContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  customLoader: {
    
  },
  customLoader_lottie: {
    flex: 1,
    height: 50,
    width: 50
  },
  customLoader_medium: {
    height: 40,
    width: 40,
  },
  customLoader_small: {
    height: 30,
    width: 30,
  },

  /**
   * 
   * PROMO WIDGET
   * 
   */
  promoWidgetContainer: {
    backgroundColor: COLORS.PRIMARY_COLOR,
    minHeight: 262,
    maxHeight: 393,
    justifyContent: "center",
  },
  promoWidgetHeaderTitle: {
    ...PRIMARY_FONT,
    ...FONT_XXLARGE,
    color: COLORS.WHITE,
    textAlign: "center",
    width: "100%",
    textTransform: "uppercase",
  },
  promoWidgetHeaderSubtitle: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.WHITE,
    textAlign: "center",
    width: "100%",
    paddingHorizontal: 35,
  },
  promoWidgetImageStyle: {
    width: "100%",
    maxWidth: null,
    height: "100%"
  },
  promoWidgetImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },


  // Doorkey Styling

  chamberRootContainer: {

  },
  chamberMainContainer: {
    flexGrow: 0,
  },
  chamberHeaderContainer: {

  },
  chamberHeaderTitleContainer: {

  },
  chamberHeaderTitle: {

  },
  chamberContainerHeaderSubTitleContainer: {

  },
  chamberHeaderSubTitle: {
    ...FONT_SMALL,
  },
  chamberHeadertertiaryTitle: {
    ...SECONDARY_FONT,
    ...FONT_XLARGE,
    textAlign: "center",
    color: COLORS.ACCENT_COLOR
  },

  chamberMainContainerChildContainer: {
    gap: 24
  },

  chamberKey_ringsAnimationWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: 'center',
    alignItems: 'center',
    width: 256,
    height: 256,
    margin: "auto",
  },
  chamberKey_innerrings: {
    borderWidth: 1,
    borderColor: '#000',
  },
  chamberKey_innerrings_text: {
    ...FONT_XSMALL,
    ...SECONDARY_FONT,
    width: 56, 
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },

  chamberKey_guidecontianer: {
    display: "flex", 
    justifyContent:'center', 
    alignItems: "center", 
    width: "100%", 
    gap: 24
  },
  chamberKey_guidecontianer_img: {
    
  },
  chamberKey_guidecontianer_guidetext: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: "center",
  },

  

  // Doorkey index

  doorkey_container: {
    minHeight: 500,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingHorizontal: 16,
    paddingVertical: 20,
    gap: 30,
    backgroundColor: COLORS.PRIMARY_COLOR,
  },
  doorkey_card_image: {
    width: "100%", 
    height: 225, 
    objectFit: "contain"
  },
  doorkey_card_roomnumber_container: {
    position: "absolute", 
    height: "100%", 
    display: "flex", 
    justifyContent: "center" 
  },
  doorkey_card_roomnumber: {
    transform: [{ rotate: '-90deg' }], 
    color: COLORS.WHITE
  },
  doorkey_card_animation_container: {
    width: "100%",
    height: "auto"
  },
  doorkey_card_animation_container_image: {
    width: "100%",
    height: 100,
    objectFit: "contain"
  },

  doorkey_card_log_container: {
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center"
  },

  doorkey_card_logo: {
    height: 50, 
    width: 55
  },


  doorKeyButton: {
    width: '90%',
  },
  doorKeyButtonText: {

  },
  doorKeyOrText: {
    marginVertical: 10,
    fontWeight: 'bold',
    alignSelf: 'center',
    ...FONT_XLARGE,
    ...PRIMARY_FONT,
    color: COLORS.PRIMARY_TEXT_COLOR
  },

  // DoorKey Otp
  doorKeyOtpEmailTxt: {
    marginHorizontal: 16,
    textAlign: 'center',
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    ...FONT_LARGE,
    ...PRIMARY_FONT,
    marginBottom: 30,
    fontWeight: '500',
  },
  doorKeyOtpPinLabel: {
    fontWeight: 'bold',
    textAlign: 'center',
    color:  COLORS.BACKGROUND_COLOR_CONTRAST,
    ...FONT_MEDIUM,
    ...PRIMARY_FONT,
    marginBottom: 15,
  },
  doorKeyOtpPinContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 35,
    marginHorizontal: 16,
  },
  doorKeyOtpPinInput: {
    width: 35,
    height: 50,
    borderBottomWidth: 1,
    borderColor: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: 'center',
    fontSize: 24,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    ...SECONDARY_FONT,
    fontWeight: undefined
  },


    /*  Floating Widget */
  floatingWidgetMainContainer: {
    position: 'absolute',
    bottom: 100,
    right: 20,
    zIndex: 1000,
    backgroundColor: COLORS.ACCENT_COLOR,
    borderRadius: 100,
    elevation: 5,

    justifyContent: 'center',
    alignItems: 'center',
    height: 56,
    width: 56,
  },
  floatingWidgetImageStyle:{
    width: 34,
    justifyContent: 'center',
    alignItems: 'center',
  },
  floatingWidgetImage: {
    height: 32,
    width: 24,
  },
  floatingWidgetFlatListContentContainer:{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: "auto",
  },
  // tabLabel : {}
  // tabContainer :{

  // ==================== Widget Info Modal ====================
  widgetInfoModalContainer: {
    width: '100%',
    backgroundColor: COLORS.BACKGROUND_COLOR,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    overflow: 'hidden',
  },
  widgetInfoModalImageWrapper: {
    width: '100%',
    position: 'relative',
  },
  widgetInfoModalHeaderImage: {
    width: '100%',
    height: 271,
    resizeMode: 'cover',
  },
  widgetInfoModalCloseBtn: {
    position: 'absolute',
    top: 16,
    right: 16,
    width: 24,
    height: 24,
    borderRadius: 18,
    backgroundColor: '#2F3215',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10,
  },
  widgetInfoModalCloseBtnTxt: {
    color: COLORS.WHITE,
    fontSize: 12,
    fontWeight: '600',
    textAlign: 'center',
  },
  widgetInfoModalContent: {
    paddingHorizontal: 32,
    paddingTop: 44,
    paddingBottom: 60,
    gap: 8,
    alignItems: 'center',
  },
  widgetInfoModalTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: 'center',
  },
  widgetInfoModalDescription: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: 'center',
  },
  // ==================== Widget Info Modal Landscape ====================
  widgetInfoModalContainer_landscape: {
    height: '100%',
    width: 360,
    backgroundColor: COLORS.BACKGROUND_COLOR,
    overflow: 'hidden',
    position: "absolute",
    right: 0,
    gap: 16,
    paddingHorizontal: 30, 
    paddingVertical: 50,
    justifyContent: "center"
  },
  customModalInnerContainerWeb: {
    height: "100%",
    width: "100%",
    maxWidth: null,
    margin: null,
  },
  widgetInfoModalImageWrapper_landscape: {
    width: '100%',
    position: 'relative',
  },
  widgetInfoModalHeaderImage_landscape: {
    width: '100%',
    height: 271,
    resizeMode: 'cover',
  },
  widgetInfoModalCloseBtn_landscape: {
    width: 24,
    height: 24,
    position: "absolute",
    top: 50,
    left: 25
  },
  widgetInfoModalCloseBtnImg_landscape: {
    tintColor: COLORS.BACKGROUND_COLOR_CONTRAST,
    filter: "invert(1)"
  },
  widgetInfoModalCloseBtnTxt_landscape: {
    color: COLORS.WHITE,
    fontSize: 12,
    fontWeight: '600',
    textAlign: 'center',
  },
  widgetInfoModalContent_landscape: {
    paddingHorizontal: 32,
    gap: 8,
    alignItems: 'center',
  },
  widgetInfoModalTitle_landscape: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: 'center',
  },
  widgetInfoModalDescription_landscape: {
    ...PRIMARY_FONT,
    ...SECONDARY_FONT,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: 'center',
  },
  innspireChatContainerBgImage: {
    display: 'none'
  },

  /**
   * Weather Widget Styles
   */
  weatherWidgetContainer: {
    borderRadius: 14,
    paddingVertical: 20,
    paddingHorizontal: 20,
    backgroundColor: '#86A6CE',
  },
  weatherWidgetDayContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  weatherWidgetIcon: {
    ...FONT_LARGE,
    fontFamily: Platform.select({
      ios: 'WeatherIcons-Regular',
      android: 'weathericons-regular-webfont',
      default: 'weathericons',
    }),
    color: COLORS.WHITE,
    marginRight: 16,
  },
  weatherWidgetTempContainer: {
    flexDirection: 'column',
    flex: 1,
  },
  weatherWidgetCurrentTemp: {
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  weatherWidgetTempVal: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.WHITE,
  },
  weatherWidgetTempSym: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.WHITE,
  },
  weatherWidgetTempUnit: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.WHITE,
  },
  weatherWidgetCondition: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.WHITE,
    marginLeft: 6,
  },
  weatherWidgetCityName: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.WHITE,
    opacity: 0.9,
  },
});
